<template>
  <v-container fluid>
    <v-data-table :headers="headersTablaCompras" :items="items_compras" :loading="loading_compras" :search="search"
      item-key="id_compra">
      <template v-slot:top>
        <v-toolbar flat>
          <v-tooltip right>
            <template v-slot:activator="{ on, attrs }">
              <v-icon @click="listarCompras()" v-bind="attrs" v-on="on">
                fa-solid fa-rotate-right
              </v-icon>
            </template>
            <span>Actualizar</span>
          </v-tooltip>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-col cols="2">
            <v-autocomplete v-model="ver_tipo_docs" :items="['FSE', 'OTROS']" label="Tipo Compras" outlined dense
              hide-details @input="onChangeTipoDoc" />
          </v-col>
          <v-col cols="3" v-if="esOtros">
            <v-autocomplete v-model="mes_compra" :items="items_mes" item-text="mes" item-value="id_mes"
              label="Mes de compra" outlined dense hide-details />
          </v-col>
          <v-spacer></v-spacer>

          <v-text-field v-model="search" label="Buscar" outlined dense hide-details></v-text-field>
          <v-spacer></v-spacer>
          <v-btn class="mx-3" color="green" dark @click="anexoventa()">Anexo Compras</v-btn>
          <v-btn color="primary" @click="nuevaCompra()" :disabled="$store.state.usuario.rol == 'Solo Vista'"> Nuevo </v-btn>
        </v-toolbar>
      </template>

      <!-- FECHA FSE -->
      <template v-slot:[`item.fecha`]="{ item }">
        <span>{{ formatoFecha(item.fecha) }}</span>
      </template>

      <!-- FECHA OTROS -->
      <template v-slot:[`item.fecha_doc`]="{ item }">
        <span>{{ formatoFecha(item.fecha_doc) }}</span>
      </template>

      <template v-slot:[`item.action_edit`]="{ item }">
        <v-icon @click="editarCompra(item)" :disabled="$store.state.usuario.rol == 'Solo Vista'"> fa-solid fa-pen-to-square </v-icon>
      </template>

      <template v-slot:[`item.action_send_dte`]="{ item }">
        <v-icon @click="enviarDTE(item)" :disabled="item.resolucion != ''">
          fa-regular fa-paper-plane
        </v-icon>
      </template>

      <template v-slot:[`item.action_gen_preview`]="{ item }">
        <v-icon @click="vistaPreviaPdf(item)" :disabled="item.resolucion != ''" :loading="loading"> fa-regular
          fa-file-pdf </v-icon>
      </template>

      <template v-slot:[`item.action_view_dte`]="{ item }">
        <v-icon @click="vistaPreviaPdfSello(item)" :disabled="item.resolucion == ''">
          fa-regular fa-file-pdf
        </v-icon>
      </template>

      <template v-slot:[`item.estatus`]="{ item }">
        <v-tooltip left color="primary" v-if="
          item.resolucion == '' && item.resolucion_invalidacion == null
        ">
          <template v-slot:activator="{ on, attrs }">
            <v-icon color="primary" v-bind="attrs" v-on="on">fa-regular fa-floppy-disk</v-icon>
          </template>
          <span>GUARDADO</span>
        </v-tooltip>

        <v-tooltip left color="success" v-else-if="
          item.resolucion != '' && item.resolucion_invalidacion == null
        ">
          <template v-slot:activator="{ on, attrs }">
            <v-icon color="success" v-bind="attrs" v-on="on">fa-regular fa-circle-check</v-icon>
          </template>
          <span>PROCESADO</span>
        </v-tooltip>

        <v-tooltip left color="error" v-else-if="
          item.resolucion_invalidacion != '' &&
          item.resolucion_invalidacion != null
        ">
          <template v-slot:activator="{ on, attrs }">
            <v-icon color="error" v-bind="attrs" v-on="on">fa-solid fa-ban</v-icon>
          </template>
          <span>ANULADO</span>
        </v-tooltip>

        <v-tooltip left color="error" v-else-if="item.estatus == 'ERROR'">
          <template v-slot:activator="{ on, attrs }">
            <v-icon color="error" v-bind="attrs" v-on="on">fa-solid fa-circle-exclamation</v-icon>
          </template>
          <span>ERROR</span>
        </v-tooltip>
      </template>
    </v-data-table>

    <v-dialog v-model="dialog_anexo" persistent max-width="500px">
      <v-card>
        <v-card-title class="text-h6">
          Seleccione el mes a descargar
        </v-card-title>

        <v-card-text>

          <v-col class="pa-17">
            <v-autocomplete v-model="sucursal" :items="items_sucursales" item-text="nombre" item-value="id_sucursal"
              label="Sucursal" outlined dense hide-details>
              <template v-slot:selection="data">
                {{ data.item.cod_sucursal }} {{ data.item.nombre }}
              </template>
              <template v-slot:item="data">
                {{ data.item.cod_sucursal }} {{ data.item.nombre }}
              </template>
            </v-autocomplete>
          </v-col>

          <v-col class="pa-17">
            <v-text-field v-model="anio" label="Año" outlined dense hide-details></v-text-field>
          </v-col>

          <v-col class="pa-17">
            <v-autocomplete v-model="mes" :items="items_mes" item-text="mes" item-value="id_mes" label="Mes" outlined
              dense hide-details>

            </v-autocomplete>
          </v-col>

        </v-card-text>

        <v-card-actions class="justify-center pt-4">
          <v-btn color="cyan" large @click="descargarArchivo('csv')" class="mx-4">
            EXCEL
          </v-btn>
          <v-btn color="red" large @click="cerrarDialogAnexo()" class="mx-2">
            CANCELAR
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog_buscar_compra" persistent max-width="500px">
      <v-card>
        <v-card-title class="text-h6">
          CONSULTAR COMPRA HACIENDA
        </v-card-title>

        <v-card-text>

          <v-col class="pa-17">
            <v-text-field v-model="fecha_doc" label="Fecha de Compra" type="datetime-local" outlined dense
              hide-details />
          </v-col>

          <v-col class="pa-17">
            <v-text-field label="Código de Generación" v-model="serie" outlined dense hide-details :error="errorCodigoG"
              :readonly="!esOtros"></v-text-field>
          </v-col>

        </v-card-text>

        <v-card-actions class="justify-center pt-4">
        <!-- <v-btn color="primary" @click="BuscarCompra()" :loading="loading" v-if="esOtros" class="mx-2">Consultar
            Hacienda</v-btn> -->
          <v-btn color="red" large @click="cerrarDialogConsultaH()" class="mx-2">
            CANCELAR
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog_cargar_json" max-width="600px">
      <v-card>
        <v-card-title class="text-h6">
          Cargar factura desde JSON
        </v-card-title>

        <v-card-text>
          <v-file-input v-model="jsonFactura" accept=".json,application/json" label="Seleccionar archivo JSON"
            prepend-icon="mdi-file-json" show-size @change="onJsonFileSelected"></v-file-input>

          <div v-if="jsonFacturaNombre" class="mt-2">
            Archivo seleccionado: <strong>{{ jsonFacturaNombre }}</strong>
          </div>

          <v-alert v-if="jsonFacturaError" type="error" dense class="mt-2">
            {{ jsonFacturaError }}
          </v-alert>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="dialog_cargar_json = false">
            Cancelar
          </v-btn>
          <v-btn color="primary" @click="procesarJsonFactura" :disabled="!jsonFactura && $store.state.usuario.rol == 'Solo Vista'">
            Procesar JSON
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>



    <v-dialog v-model="dialog_compras" width="3000" scrollable persistent>
      <v-card color="grey">
        <v-card-text class="px-0">
          <!-- CABECERA -->
          <v-card>
            <v-card-text>
              <v-row no-gutters>

                <v-col cols="6" md="2" class="pa-1">
                  <v-text-field v-model="nombre_usuario" label="Usuario" outlined dense hide-details
                    readonly></v-text-field>
                </v-col>

                <v-spacer></v-spacer>

                <v-col cols="6" md="8" class="pa-1"></v-col>

                <v-spacer></v-spacer>

                <v-col cols="12" md="2" class="pa-1">
                  <v-text-field v-model="rubro" label="Sector Empresa" outlined dense hide-details
                    readonly></v-text-field>
                </v-col>

                <v-row>

                  <v-col cols="6" md="3" class="pa-1"></v-col>

                  <v-col cols="6" md="2" class="pa-17">
                    <v-text-field v-model="anio_ingreso" label="Año" v-if="esOtros" outlined dense
                      hide-details></v-text-field>
                  </v-col>

                  <v-col cols="12" md="2" class="pa-17" v-if="esOtros">
                    <v-autocomplete v-model="mes_compra" :items="items_mes" item-text="mes" item-value="id_mes"
                      label="Mes de compra" outlined dense hide-details />
                  </v-col>

                  <v-col cols="12" md="2" class="pa-17" v-if="esOtros">
                    <v-text-field v-model="fecha_doc" label="Fecha de Compra" type="datetime-local" outlined dense
                      hide-details />
                  </v-col>

                </v-row>

                <v-row>

                  <v-col cols="12" md="4" class="pa-1">
                    <v-autocomplete v-model="sucursal" :items="items_sucursales" item-text="nombre"
                      item-value="id_sucursal" label="Sucursal" auto-select-first outlined dense hide-details
                      @input="listarTipoDocs(), listarPuntosVenta('manual')"></v-autocomplete>
                  </v-col>

                  <v-col cols="12" md="4" class="pa-1">
                    <v-autocomplete v-model="punto_venta" :items="items_punto_venta" item-text="descripcion"
                      item-value="id_punto_venta" label="Punto de venta" outlined dense hide-details
                      @input="listarTipoDocs()"></v-autocomplete>
                  </v-col>

                  <v-col cols="12" md="4" class="pa-1">
                    <v-autocomplete v-model="tipo_doc_fiscal" :items="tiposDocFiltrados" item-text="nombre_doc_fiscal"
                      item-value="id_tipo_doc_fiscal" label="Tipo Documento" outlined dense hide-details return-object
                      @change="listarTipoDocs()" @input="listarDocSeleccionado()" />
                  </v-col>

                  <template v-slot:[`item.fecha`]="{ item }">
                    <span> {{ formatoFecha(item.fecha) }}</span>
                  </template>
                  <v-col cols="12" md="6" class="pa-1">
                    <v-text-field v-model="fecha" label="Fecha y hora" type="datetime-local" v-if="esFSE" outlined dense
                      hide-details></v-text-field>
                  </v-col>


                  <v-col cols="12" md="6" class="pa-1">
                    <v-autocomplete label="Condición pago" v-model="cond_pago" :items="items_cond_pago" item-text="cod"
                      item-value="cod" :error="errorCondicionPago" outlined dense hide-details>
                      <template v-slot:selection="data">
                        {{ data.item.cod }} {{ data.item.nombre }}
                      </template>
                      <template v-slot:item="data">
                        {{ data.item.cod }} {{ data.item.nombre }}
                      </template>
                    </v-autocomplete>
                  </v-col>

                  <v-col cols="12" md="6" class="pa-1">

                    <v-text-field v-model="documento" label="Número de Control" outlined dense hide-details
                      :readonly="!esOtros"></v-text-field>
                  </v-col>

                  <v-col cols="12" md="6" class="pa-1">
                    <v-text-field label="Código de Generación" v-model="serie" outlined dense hide-details
                      :error="errorCodigoG" :readonly="!esOtros"></v-text-field>
                  </v-col>

                  <v-col cols="12" md="6" class="pa-1">
                    <v-text-field v-model="resolucion" label="Resolucion" outlined dense hide-details
                      :readonly="!esOtros"></v-text-field>
                  </v-col>

                  <v-col cols="12" md="6" class="pa-1">
                    <v-text-field v-model="fecha_recepcion" label="Fecha de recepción" type="datetime-local" outlined
                      dense hide-details :readonly="!esOtros"></v-text-field>
                  </v-col>

                </v-row>

                <v-row>
                  <v-col cols="12" md="2" class="pa-1">
                    <v-checkbox label="Con Renta 10%" v-model="con_renta" @change="calculoRetencionRenta()" dense
                      hide-details></v-checkbox>
                  </v-col>

                  <v-col cols="12" md="2" class="pa-1">
                    <v-checkbox label="Emitir como anulado" v-model="emitir_anulado" dense hide-details></v-checkbox>
                  </v-col>

                  <v-col cols="12" md="3" class="pa-1"></v-col>

                  <v-col cols="12" md="1" class="pa-1">
                    <v-btn color="secondary" @click="abrirDialogoJson()" v-if="esOtros" class="pa-1">
                      Cargar JSON factura
                    </v-btn>
                  </v-col>

                  <v-col cols="12" md="1" class="pa-1"></v-col>

                  <!-- <v-col cols="12" md="1" class="pa-1">
                    <v-btn color="primary" @click="ConsultarH()" :loading="loading" v-if="esOtros"
                      class="pa-1" :disabled="$store.state.usuario.rol == 'Solo Vista'">
                      Consultar
                      Hacienda</v-btn>
                  </v-col> -->
                  


                </v-row>
              </v-row>
            </v-card-text>
          </v-card>

          <!-- DETALLES PROVEEDOR -->
          <v-card class="mt-3">
            <v-card-title>PROVEEDORES</v-card-title>
            <v-card-text>
              <v-row no-gutters>
                <v-col cols="12" md="3" class="pa-1">
                  <v-text-field v-model="cod_prov" label="Código" outlined dense hide-details></v-text-field>
                </v-col>
                <v-col cols="auto" class="pa-1">
                  <v-btn color="primary" @click="listarProveedoress()" :disabled="$store.state.usuario.rol == 'Solo Vista'">
                    <v-icon>fas fa-search</v-icon>
                  </v-btn>
                </v-col>
                <v-col cols="auto" class="pa-1">
                  <v-btn color="success" @click="dialogNuevoProveedor()" :disabled="$store.state.usuario.rol == 'Solo Vista'">
                    <v-icon>fas fa-plus</v-icon>
                  </v-btn>
                </v-col>
                <v-col cols="auto" class="pa-1">
                  <v-btn color="grey" @click="dialogEditarProveedor()" :disabled="id_proveedor == 0 || $store.state.usuario.rol == 'Solo Vista'">
                    <v-icon color="white">fas fa-edit</v-icon>
                  </v-btn>
                </v-col>

                <v-spacer></v-spacer>



                <v-col cols="12" class="pa-1">
                  <v-text-field v-model="nombre_prov" label="Nombre" outlined dense hide-details></v-text-field>
                </v-col>
                <v-col cols="12" md="6" class="pa-1">
                  <v-text-field v-model="receptor_prov" label="Receptor" outlined dense hide-details></v-text-field>
                </v-col>
                <v-col cols="12" md="3" class="pa-1">
                  <v-text-field v-model="tamaño_prov" label="Tamaño" outlined dense hide-details></v-text-field>
                </v-col>
                <v-col cols="12" md="3" class="pa-1">
                  <v-text-field v-model="registro_prov" label="Registro" outlined dense hide-details></v-text-field>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>

          <!-- GASTOS -->
          <v-card class="mt-3">
            <v-card-title>GASTOS</v-card-title>
            <v-card-text>

              <v-row no-gutters>
                <v-col cols="12" md="6" class="pa-1">
                  <v-checkbox label="Seleccionar Manualmente" v-model="selec_manual" @change="modoManual(selec_manual)"
                    dense hide-details></v-checkbox>
                </v-col>

                <v-col cols="12" md="12" class="pa-1">
                </v-col>

                <v-col cols="12" md="4" class="pa-1">
                  <v-autocomplete v-model="tipo_operacion" :items="items_tipo_operacion" item-text="tipo_operacion"
                    item-value="codigo" :value-comparator="(a, b) => Number(a) === Number(b)" label="Tipo Operación"
                    outlined dense hide-details @change="actualizarCostoGastos">
                    <template v-slot:selection="data">
                      {{ data.item.codigo }} {{ data.item.tipo_operacion }}
                    </template>
                    <template v-slot:item="data">
                      {{ data.item.codigo }} {{ data.item.tipo_operacion }}
                    </template>
                  </v-autocomplete>
                </v-col>

                <v-col cols="12" md="4" class="pa-1">
                  <v-autocomplete v-model="clasificacion" :items="items_clasificacion" item-text="clasificacion"
                    item-value="codigo" :value-comparator="(a, b) => Number(a) === Number(b)" label="Clasificación"
                    outlined dense hide-details @change="actualizarCostoGastos">
                    <template v-slot:selection="data">
                      {{ data.item.codigo }} {{ data.item.clasificacion }}
                    </template>
                    <template v-slot:item="data">
                      {{ data.item.codigo }} {{ data.item.clasificacion }}
                    </template>
                  </v-autocomplete>
                </v-col>

                <v-col cols="12" md="4" class="pa-1">
                  <v-autocomplete v-model="costo_gastos" :items="items_costogasto" item-text="costo_gasto"
                    item-value="id_costo_gasto" label="Tipo de Costo/Gasto" outlined dense hide-details>
                    <template v-slot:selection="data">
                      {{ data.item.codigo }} {{ data.item.costo_gasto }}
                    </template>
                    <template v-slot:item="data">
                      {{ data.item.codigo }} {{ data.item.costo_gasto }}
                    </template>
                  </v-autocomplete>
                </v-col>





              </v-row>
            </v-card-text>
          </v-card>

          <v-dialog v-model="dialogIngresoAutomaticoDTE" width="1000">
            <v-card>
              <v-card-title>Importar Documento Tributario Electrónico</v-card-title>
              <v-card-text>

                <v-row>

                  <v-col cols="12" md="12">
                    <v-card outlined>
                      <v-card-title>DESDE DATOS</v-card-title>
                      <v-row no-gutters>
                        <v-col cols="12" md="5" class="pa-2">
                          <v-text-field label="Fecha" v-model="fecha_dte" type="datetime-local" outlined dense
                            hide-details></v-text-field>
                        </v-col>

                        <v-col cols="12" md="7" class="pa-2">
                          <v-text-field label="Codigo de Generación" v-model="codigo_generacion" outlined dense
                            hide-details></v-text-field>
                        </v-col>

                        <v-col cols="12" md="5" class="pa-2"></v-col>

                        <v-col cols="12" md="8" class="pa-1">
                          <v-checkbox label="Crear Proveedor si no existe" v-model="proveedor_dte" dense
                            hide-details></v-checkbox>
                        </v-col>

                        <v-col cols="12" md="4" class="pa-1"></v-col>

                        <v-col cols="12" md="2" class="pa-1"></v-col>

                        <v-col cols="auto" class="pa-1">
                          <v-btn>
                            <v-icon left>fa-solid fa-file-circle-plus</v-icon>
                            Validar Documento MH
                          </v-btn>
                        </v-col>


                        <v-col cols="auto" class="pa-1">
                          <v-btn>
                            <v-icon left>fa-solid fa-file-circle-plus</v-icon>
                            Ingresar Documento
                          </v-btn>
                        </v-col>

                        <v-col cols="auto" class="pa-1">
                          <v-btn>
                            <v-icon left>fa-solid fa-copy</v-icon>
                            Copiar Datos
                          </v-btn>
                        </v-col>

                      </v-row>
                    </v-card>
                  </v-col>
                </v-row>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="dialogIngresoAutomaticoDTE = false">Cerrar</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>



          <!-- TABLA DE SERVICIOS -->
          <v-card class="mt-3">
            <v-card-title>SERVICIOS</v-card-title>
            <v-card-text>
              <v-data-table :headers="headers_productos" :items="items_productos">
                <template v-slot:top>
                  <v-toolbar flat>
                    <v-row no-gutters justify="center" v-if="$vuetify.breakpoint.mdAndUp">
                      <v-col cols="12" md="auto" align-self="center">
                      </v-col>

                      <v-col cols="12" md="1">
                        <v-text-field v-model="cantidad_prod" label="Cantidad" outlined dense hide-details class="mx-1"
                          @input="calculoTotal"></v-text-field>
                      </v-col>
                      <v-col cols="12" md="1">
                        <v-text-field v-model="cod_prod" label="Código" outlined dense hide-details class="mx-1"
                          :error="errorCodigo"></v-text-field>
                      </v-col>

                      <v-btn outlined @click="listarProductos()" :disabled="$store.state.usuario.rol == 'Solo Vista'">
                        <v-icon> fa-solid fa-magnifying-glass </v-icon>
                      </v-btn>

                      <v-col cols="12" md="5">
                        <v-text-field v-model="nombre_prod" label="Servicio General" outlined dense hide-details
                          class="mx-1"></v-text-field>
                      </v-col>

                      <v-col cols="12" md="1">
                        <v-text-field v-model="precio" label="Precio Unitario" type="number" outlined dense hide-details
                          class="mx-1" @input="calculoTotal"></v-text-field>
                      </v-col>

                      <v-col cols="12" md="1">
                        <v-text-field v-model="descuento_servicio" label="%Descuento" type="number"
                          @change="calculoDescuento()" outlined dense hide-details class="mx-1">
                        </v-text-field>
                      </v-col>


                      <v-col cols="12" md="1">
                        <v-text-field v-model="total_prod" label="Total" outlined dense hide-details
                          class="mx-1"></v-text-field>
                      </v-col>

                      <v-col cols="12" md="1" align-self="center">
                        <v-btn @click="agregarProducto()" :disabled="$store.state.usuario.rol == 'Solo Vista'">
                          <v-icon color="green">
                            fa-solid fa-square-check
                          </v-icon>
                        </v-btn>
                      </v-col>
                    </v-row>
                    <v-row no-gutters v-else>
                      <v-menu offset-y>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn color="primary" dark v-bind="attrs" v-on="on">
                            Opciones
                          </v-btn>
                        </template>
                        <v-card>
                          <v-card-text>
                            <v-row no-gutters>
                              <v-col cols="12" align-self="center" class="ma-1">
                                <v-btn outlined block @click="listarProductos()">
                                  <v-icon> fa-solid fa-magnifying-glass </v-icon>
                                </v-btn>
                              </v-col>
                              <v-col cols="12" class="ma-1">
                                <v-text-field v-model="cantidad_prod" label="Cantidad" outlined dense hide-details
                                  @input="calculoTotal"></v-text-field>
                              </v-col>
                              <v-col cols="12" class="ma-1">
                                <v-text-field v-model="cod_prod" label="Código" outlined dense
                                  hide-details></v-text-field>
                              </v-col>
                              <v-col cols="12" class="ma-1">
                                <v-text-field v-model="nombre_prod" label="Nombre" outlined dense
                                  hide-details></v-text-field>
                              </v-col>
                              <v-col cols="12" class="ma-1">
                                <v-text-field v-model="precio" label="Precio Unitario" outlined dense
                                  hide-details></v-text-field>
                              </v-col>
                              <v-col cols="12" class="ma-1">
                                <v-text-field v-model="descuento_servicio" label="$Descuento" type="number"
                                  @change="calculoDescuento()" outlined dense hide-details></v-text-field>
                              </v-col>
                              <v-col cols="12" class="ma-1">
                                <v-text-field v-model="total_prod" label="Total" outlined dense
                                  hide-details></v-text-field>
                              </v-col>
                              <v-col cols="12" class="ma-1" align-self="center">
                                <v-btn @click="agregarProducto()" block>
                                  <v-icon color="green">
                                    fa-solid fa-square-check
                                  </v-icon>
                                </v-btn>
                              </v-col>
                            </v-row>
                          </v-card-text>
                        </v-card>
                      </v-menu>
                    </v-row>
                  </v-toolbar>
                </template>

                <template v-slot:[`item.action_edit`]="{ item }">
                  <v-icon @click="editarProducto(item)">
                    fa-solid fa-pen-to-square
                  </v-icon>
                </template>

                <template v-slot:[`item.action_delete`]="{ item }">
                  <v-icon @click="removerProducto(item)">
                    fa-solid fa-trash-can
                  </v-icon>
                </template>

                <template v-slot:[`item.descuento`]="{ item }">
                  <span> % {{ Number(item.descuento).toFixed(2) }}</span>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>

          <!-- CALCULOS -->
          <v-card class="mt-3">
            <v-card-text>
              <v-row>
                <v-col cols="12" md="4">
                  <v-card outlined>
                    <v-card-title>COMPRAS GRAVADAS</v-card-title>
                    <v-row no-gutters>
                      <v-col cols="12" class="pa-2">
                        <v-text-field label="Internas/Importaciones" v-model="internas_importaciones"
                          prepend-inner-icon="fa-solid fa-dollar-sign" :error="errorInternas_Importaciones" outlined
                          dense hide-details></v-text-field>
                      </v-col>

                    </v-row>
                  </v-card>
                </v-col>

                <v-col cols="12" md="4">
                  <v-card outlined>
                    <v-card-title>RENTA</v-card-title>
                    <v-row no-gutters>
                      <v-col cols="12" class="pa-2">
                        <v-text-field label="Renta 10%" v-model="renta" prepend-inner-icon="fa-solid fa-dollar-sign"
                          outlined dense hide-details></v-text-field>
                      </v-col>
                    </v-row>
                  </v-card>
                </v-col>



                <v-col cols="12" md="4">
                  <v-card outlined>
                    <v-card-title>NO SUJETO </v-card-title>
                    <v-row no-gutters>
                      <v-col cols="12" class="pa-2">
                        <v-text-field label="No Sujeto" v-model="no_sujeto" prepend-inner-icon="fa-solid fa-dollar-sign"
                          outlined dense hide-details></v-text-field>
                      </v-col>
                    </v-row>
                  </v-card>
                </v-col>

                <v-col cols="12" md="4">
                  <v-card outlined>
                    <v-card-title>COMPRAS EXENTAS</v-card-title>
                    <v-row no-gutters>
                      <v-col cols="12" class="pa-2">
                        <v-text-field label="Internas/Importaciones" v-model="internas_importaciones_exentas"
                          prepend-inner-icon="fa-solid fa-dollar-sign" :error="errorInternas_Importaciones" outlined
                          dense hide-details></v-text-field>
                      </v-col>
                    </v-row>
                  </v-card>
                </v-col>

                <v-col cols="12" md="4">
                  <v-card outlined>
                    <v-card-title>A-TERCEROS-IVA</v-card-title>
                    <v-row no-gutters>
                      <v-col cols="12" class="pa-2">
                        <v-text-field label="IVA" v-model="iva" prepend-inner-icon="fa-solid fa-dollar-sign" outlined
                          dense hide-details></v-text-field>
                      </v-col>
                    </v-row>
                  </v-card>
                </v-col>




                <v-col cols="12" md="4">
                  <v-card outlined>
                    <v-row no-gutters>
                      <v-col cols="12" class="pa-2">
                        <v-text-field label="Otros Cargos" v-model="otros_cargos"
                          prepend-inner-icon="fa-solid fa-dollar-sign" outlined dense hide-details></v-text-field>
                      </v-col>
                      <v-col cols="12" class="pa-2">
                        <v-text-field label="Descuento" v-model="descuento" prepend-inner-icon="fa-solid fa-dollar-sign"
                          outlined dense hide-details></v-text-field>
                      </v-col>
                    </v-row>
                  </v-card>
                </v-col>

                <v-col cols="12" md="4">
                  <v-card outlined>
                    <v-card-title>IMPUESTOS COMBUSTIBLES</v-card-title>
                    <v-row no-gutters>
                      <v-col cols="12" class="pa-2">
                        <v-text-field label="FOVIAL" v-model="fovial" prepend-inner-icon="fa-solid fa-dollar-sign"
                          outlined dense hide-details @input="calcularTotales"></v-text-field>
                      </v-col>
                      <v-col cols="12" class="pa-2">
                        <v-text-field label="COTRANS" v-model="cotrans" prepend-inner-icon="fa-solid fa-dollar-sign"
                          outlined dense hide-details @input="calcularTotales"></v-text-field>
                      </v-col>
                    </v-row>
                  </v-card>
                </v-col>

                <v-col cols="12" md="4">
                  <v-card outlined>
                    <v-card-title>RESUMEN DE OPERACIONES</v-card-title>
                    <v-row no-gutters>
                      <v-col cols="12" class="pa-2">
                        <v-text-field label="Total operación" v-model="total_operacion"
                          prepend-inner-icon="fa-solid fa-dollar-sign" :error="errorTotal_Operacion" outlined dense
                          hide-details></v-text-field>
                      </v-col>
                      <v-col cols="12" class="pa-2">
                        <v-text-field label="Total a pagar" v-model="total_pagar"
                          prepend-inner-icon="fa-solid fa-dollar-sign" :error="errorTotal_Pagar" outlined dense
                          hide-details></v-text-field>
                      </v-col>
                    </v-row>
                  </v-card>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-card-text>
        <v-card-actions class="white">
          <v-btn color="primary" @click="crearCompra()" v-if="flag == 1" :loading="loading" :disabled="$store.state.usuario.rol == 'Solo Vista'">
            Guardar
          </v-btn>
          <v-btn color="primary" @click="actualizarCompra()" v-if="flag == 2" :disabled="resolucion != '' && $store.state.usuario.rol == 'Solo Vista'"
            :loading="loading" >Actualizar</v-btn>

          <v-btn color="red" @click="confirmarAnularDocumento()"
            v-if="esFSE && ((flag == 2 && $store.state.usuario.rol == 'Administrador') || $store.state.usuario.rol == 'IT')"
            :disabled="resolucion == ''">
            Anular
          </v-btn>

          <v-btn color="red" @click="eliminarCompra()" v-if="
            flag == 2 &&
            ($store.state.usuario.rol === 'Administrador' ||
              $store.state.usuario.rol === 'IT' ||
              $store.state.usuario.idUsuario == 44) &&
            esOtros
          " :loading="loading_eliminar_compra" dark>Eliminar</v-btn>

          <v-spacer></v-spacer>
          <v-btn text @click="cerrarDialogCompras()">Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog_proveedores" width="1000">
      <v-data-table :headers="headers_proveedores" :items="items_proveedores" :search="search"
        @dblclick:row="setProveedor">
        <template v-slot:top>
          <v-toolbar flat>
            <v-toolbar-title>Proveedores</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-spacer></v-spacer>
            <v-text-field v-model="search" label="Buscar" outlined dense hide-details></v-text-field>
            <v-spacer></v-spacer>
            <div style="color: black">[Hacer doble click para seleccionar]</div>
          </v-toolbar>
        </template>
      </v-data-table>
    </v-dialog>

    <v-dialog v-model="dialog_productos" width="1000">
      <v-data-table :headers="headers_productos_list" :items="items_productos_list" @dblclick:row="setProductos">
        <template v-slot:top>
          <v-toolbar flat>
            <v-toolbar-title>Productos</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-spacer></v-spacer>
            <div style="color: black">[Hacer doble click para seleccionar]</div>
          </v-toolbar>
        </template>
      </v-data-table>
    </v-dialog>

    <v-dialog v-model="dialog_eliminar_producto_detalle" width="500">
      <v-card>
        <v-card-title> ¿Esta seguro de eliminar este producto? </v-card-title>
        <v-card-actions>
          <v-btn color="red" dark @click="eliminarProductoDetalle()">Eliminar</v-btn>
          <v-spacer></v-spacer>
          <v-btn text @click="dialog_eliminar_producto_detalle = false">Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog_confirmar_anular" width="500">
      <v-card>
        <v-card-title>¿Esta seguro de anular el documento?</v-card-title>
        <v-card-actions>
          <v-btn color="red" @click="anularFactura()">Confirmar</v-btn>

          <v-spacer></v-spacer>
          <v-btn @click="dialog_confirmar_anular = !dialog_confirmar_anular">Cancelar</v-btn>
          <v-spacer></v-spacer>

        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog_eliminar_compra" width="500">
      <v-card>
        <v-card-title>¿Esta seguro de eliminar la factura <br />
          {{ documento }}?</v-card-title>
        <v-card-actions>
          <v-btn color="red" dark @click="confirmarEliminarCompra()">Eliminar</v-btn>
          <v-spacer></v-spacer>
          <v-btn text @click="dialog_eliminar_compra = false">Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog_preview_report" fullscreen persistent>
      <v-toolbar flat dense>
        <v-toolbar-title> DOCUMENTO </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-icon @click="dialog_preview_report = !dialog_preview_report">far fa-times-circle</v-icon>
      </v-toolbar>
      <iframe :src="base64_doc" id="myPDF" frameborder="0" />
    </v-dialog>

    <ProveedoresCrearEditar :estado_dialog.sync="dialog_crear_editar_proveedor"
      :estado_nuevo_editar_dialog.sync="estado_crear_editar_proveedor"
      :errorDocumentoIdentificador="errorDocumentoIdentificador" />

    <v-snackbar v-model="snackbar" timeout="4000" color="blue" multi-line elevation="24" outlined top right>
      <v-icon>fa-solid fa-circle-info</v-icon>
      {{ snackbar_text }}
    </v-snackbar>
  </v-container>
</template>

<script>
import axios from "axios";
import settings from "@/settings/settings";
import ProveedoresCrearEditar from "@/views/Proveedor_Crear_Editar.vue";


export default {
  data() {
    return {
      ver_tipo_docs: localStorage.getItem('comprasTipoDoc') || 'FSE',
      flag: 1,
      headers_compras: [
        { text: "Fecha", value: "fecha" },
        { text: "Documento", value: "documento" },
        { text: "Tipo Doc", value: "cod_doc_fiscal" },
        { text: "Proveedor", value: "nom_proveedor" },
        { text: "Estatus", value: "estatus", align: "center" },
        {
          text: "Enviar DTE",
          value: "action_send_dte",
          align: "center",
          sortable: false,
        },
        {
          text: "Ver previa",
          value: "action_gen_preview",
          align: "center",
          sortable: false,
        },
        {
          text: "Ver DTE",
          value: "action_view_dte",
          align: "center",
          sortable: false,
        },
        { text: "Editar", value: "action_edit", align: "center" },

      ],
      headers_compras_otros: [
        { text: "Fecha", value: "fecha_doc" },
        { text: "Documento", value: "documento" },
        { text: "Tipo Doc", value: "cod_doc_fiscal" },
        { text: "Proveedor", value: "nom_proveedor" },
        { text: "Total Pagar", value: "total_pagar", align: "center" },
        { text: "Editar", value: "action_edit", align: "center" },
      ],
      anulado: "",
      renta: "",
      anio: "",
      anio_ingreso: new Date().getFullYear().toString(),
      fecha_ingreso: "",
      fecha_doc: "",
      mes: "",
      mes_compra: new Date().getMonth() + 1,
      mes_compra_filtro: new Date().getMonth() + 1,
      items_compras_all: [],
      sucursal: "",
      punto_venta: "",
      items_punto_venta: [],
      cod_sucursal_mh: "",
      cod_punto_venta_mh: "",
      items_mes: [],
      items_compras: [],
      snackbar: false,
      snackbar_text: "",
      dialog_compras: false,
      dialog_anexo: false,
      dialog_buscar_compra: false,
      id_compra: 0,
      id_empresa: 0,
      items_tipo_doc_fiscales: [],
      tipo_doc_fiscal: "",
      id_tipo_doc_fiscal: 0,
      items_cond_pago: [
        { cod: "01", nombre: "CONTADO" },
        { cod: "02", nombre: "CREDITO" },
      ],
      cond_pago: "",
      items_sucursales: [],

      items_tipo_operacion: [],
      items_clasificacion: [],
      items_costogasto: [],


      items_usuario: [],
      items_rubro: [],
      id_sucursal: 0,
      id_usuario: 0,
      nombre_usuario: "",
      fecha: "",
      documento: "DTE-00-00000000-000000000000000",
      comp_retencion: "",
      con_renta: true,
      serie: "",
      resolucion: "",
      fecha_recepcion: "",
      emitir_anulado: false,
      num_poliza: "",
      quedan: "",

      errorDocumentoIdentificador: false,

      internas_importaciones: 0,
      iva: 0,
      renta: 0,
      total_operacion: 0,
      total_pagar: 0,
      //PROVEEDORES
      dialog_proveedores: false,
      headers_proveedores: [
        { text: "Código", value: "codigo" },
        { text: "Nombre", value: "nombre" },
        { text: "Dirección", value: "direccion" },
        { text: "Teléfono", value: "telefono" },
        { text: "Registro", value: "registro" },
        { text: "Documento", value: "documento_identificador" },
      ],
      items_proveedores: [],
      id_proveedor: 0,
      cod_prov: "",
      con_retencion_prov: false,
      sucursal: "",
      tipo_doc_fiscal: "",
      con_percepcion_prov: false,
      nombre_prov: "",
      receptor_prov: "",
      tamaño_prov: "",
      registro_prov: "",
      search: "",
      loading_eliminar_compra: false,
      dialog_eliminar_compra: false,

      //PRODUCTOS
      headers_productos: [
        { text: "Cantidad", value: "cantidad_prod" },
        { text: "Código", value: "cod_producto" },
        { text: "Nombre", value: "nom_producto" },
        { text: "Precio Unitario", value: "precio" },
        { text: "Descuento", value: "descuento_servicio" },
        { text: "Total", value: "total_prod" },
        { text: "Editar", value: "action_edit", align: "center" },
        { text: "Eliminar", value: "action_delete", align: "center" },
      ],
      items_productos: [],
      dialog_productos: false,
      headers_productos_list: [
        { text: "Código", value: "cod_producto" },
        { text: "Nombre", value: "nom_producto" },
        { text: "Precio", value: "precio" },
      ],
      items_productos_list: [],

      cod_prod: "",
      nombre_prod: "",
      precio: 0,
      cantidad_prod: 1,
      total_prod: 0,

      //DETALLE PRODUCTO
      id_detalle_compra: 0,
      dialog_eliminar_producto_detalle: false,
      dialog_crear_editar_proveedor: false,
      estado_crear_editar_proveedor: "",

      loading: false,
      loading_compras: false,

      base64_doc: "",
      dialog_confirmar_anular: false,
      dialog_preview_report: false,

      //Validaciones

      errorFecha: false,
      errorDocumentoIdentificador: false,
      errorSucursal: false,
      errorCondicionPago: false,
      errorInternas_Importaciones: false,
      errorTotal_Operacion: false,
      errorTotal_Pagar: false,
      errorCodigoG: false,
      errorCodigo: false,



      rubro: "",
      selec_manual: false,
      tipo_operacion: "",
      clasificacion: "",
      costo_gastos: "",

      descuento_servicio: 0,

      fovial: 0.00,
      cotrans: 0.00,
      gravadas: 0.00,
      exentas: 0.00,
      descuentos: 0.00,
      no_sujeto: 0.00,
      otros_cargos: 0.00,
      retencion: 0.00,
      percepcion: 0.00,
      anticipo: 0.00,
      importaciones: 0,

      internas_exentas: 0.00,
      internas_importaciones_exentas: 0.00,

      monto_descuento: 0,
      descuento: 0,

      s_percepcion: false,
      s_retencion: false,

      flag_descuento: false,

      dialogIngresoAutomaticoDTE: false,

      fecha_dte: "",
      codigo_generacion: "",
      proveedor_dte: false,
      UsuariosPermitidos: [43, 36, 44, 7, 6, 5, 3, 2, 1],

      //Carga JSON

      dialog_cargar_json: false,
      jsonFactura: null,
      jsonFacturaNombre: '',
      jsonFacturaError: '',

    };
  },

  components: {
    ProveedoresCrearEditar,
  },

  created() {

    this.listarUsuarios();
    this.listarRubro();
    this.listarMes();
    this.listarProveedores();


    if (this.$store.state.emp.id_empresa) {
      this.inicializarDatos();
    } else {

    };
  },

  watch: {
    "$store.state.emp.id_empresa": function (newVal, oldVal) {
      if (newVal) {
        this.inicializarDatos();
      }
    },
    "$store.state.usuario.id_usuario": function (newVal, oldVal) {
      if (newVal) {
        this.inicializarDatos();
      }
    },
    cantidad_prod(newVal) {
      this.calculoTotal();
      this.calcularTotales();
    },
    precio(newVal) {
      this.calculoTotal();
      this.calcularTotales();
    },

    descuento_servicio(newVal) {
      this.calculoDescuento();
      this.calcularTotales();
    },
    internas_importaciones(newVal) {
      this.calcularTotales();
    },
    iva(newVal) {
      this.calcularTotales();
    },

    tipo_operacion(newVal) {
      this.actualizarCostoGastos();
      this.calcularTotales();
    },
    clasificacion(newVal) {
      this.actualizarCostoGastos();
      this.calcularTotales();
    },
    costo_gastos(newVal) {
      this.calcularTotales();
    },
    selec_manual(newVal) {
      this.modoManual(newVal);
    },
    esOtros(val) {
      if (val) {
        this.documento = ''
        this.serie = ''
        this.resolucion = ''
        this.fecha_recepcion = ''
      }
    }


  },

  computed: {
    esOtros() {
      return this.ver_tipo_docs === 'OTROS'
    },
    esFSE() {
      return this.ver_tipo_docs === 'FSE'
    },
    headersTablaCompras() {
      return this.esOtros ? this.headers_compras_otros : this.headers_compras;
    },
    tiposDocFiltrados() {
      return this.esFSE
        ? (this.items_tipo_doc_fiscales || []).filter(d => d.cod_doc_fiscal === 'FSE')
        : (this.items_tipo_doc_fiscales || []);
    }
  },

  methods: {
    inicializarDatos() {
      this.listarCompras();
      this.listarSucursales();
      this.listarTipoOperacion();
      this.listarClasificacion();
      this.listarCostoGasto();
      this.listarUsuarioSucursal();

    },

    async obtenerAmbiente() {
      return (await axios.get("api/DetallesEmpresas/ObtenerAmbiente/" + this.$store.state.emp.id_empresa)).data
    },

    listarMes() {
      axios.get("api/Mes/Listar")
        .then((response) => {
          this.items_mes = (response.data || []).map(m => ({
            ...m,
            id_mes: Number(m.id_mes)
          }));
        });
    },

    getProveedorByIdLocal(id_proveedor) {
      if (this.items_proveedores && this.items_proveedores[id_proveedor]) {
        return this.items_proveedores[id_proveedor];
      }
      return null;
    },

    listarProveedores() {
      return axios
        .get("api/Proveedores/Listar/" + this.$store.state.emp.id_empresa)
        .then((response) => {
          this.items_proveedores = response.data.reduce((map, proveedor) => {
            map[proveedor.id_proveedor] = proveedor;
            return map;
          }, {});


        })
        .catch((error) => {
          console.error("Error al listar los proveedores:", error);
          this.snackbar_text = "No se pudieron cargar los proveedores";
          this.snackbar = true;
        });
    },

    anexoventa() {
      this.dialog_anexo = true;
    },
    ConsultarH() {
      this.dialog_buscar_compra = true;
    },



    descargarArchivo(tipo) {
      if (tipo === 'csv') {
        this.obtenerDatosParaCSVCompras();
      }
      this.dialog_anexo = false;
    },

    // Método para generar el CSV de Compras

    obtenerDatosParaCSVCompras() {
      this.loading_compras = true;


      axios.get("api/Compras/Listar/" + this.$store.state.emp.id_empresa)
        .then(response => {
          if (Array.isArray(response.data)) {

            const comprasData = response.data.filter(item => {
              const fecha = new Date(item.fecha);
              const itemAnio = fecha.getFullYear();
              const itemMes = fecha.getMonth() + 1;

              return itemAnio === parseInt(this.anio) && itemMes === parseInt(this.mes);
            }).map(compra => {
              const proveedor = this.getProveedorByIdLocal(compra.id_proveedor);
              if (proveedor) {
                compra.nit_ncr = proveedor.id_identificador === "1"
                  ? proveedor.documento_identificador.replace(/-/g, "")
                  : "";

                compra.dui = proveedor.id_identificador = "2"
                  ? proveedor.documento_identificador.replace(/-/g, "")
                  : "";

                compra.proveedor = proveedor.nombre || "Sin Nombre";
              } else {
                compra.nit_ncr = "N/A";
                compra.dui = "N/A";
                compra.proveedor = "Proveedor Desconocido";
              }
              return compra;
            });

            // Verifica si hay facturas para generar el CSV
            if (comprasData.length > 0) {
              this.descargarCSVCompras(comprasData);


            } else {
              this.snackbar_text = "No hay documentos para el año y mes seleccionados";
              this.snackbar = true;
            }
          } else {
            this.snackbar_text = "Error al obtener los datos de facturas";
            this.snackbar = true;
          }
        })
        .catch(error => {
          console.error("Error al obtener datos de facturas:", error);
          this.snackbar_text = "No se pudo obtener información de las facturas";
          this.snackbar = true;
        })
        .finally(() => {
          this.loading_compras = false;
        });
    },

    descargarCompras() {
      if (this.$store.state.emp.id_empresa) {
        this.loading_compras = true;

        axios.get("api/Compras/Listar/" + this.$store.state.emp.id_empresa)
          .then((response) => {
            if (Array.isArray(response.data)) {
              const comprasData = response.data.filter(item => {
                const fecha = new Date(item.fecha);
                const itemAnio = fecha.getFullYear();
                const itemMes = fecha.getMonth() + 1;

                return itemAnio === parseInt(this.anio) && itemMes === parseInt(this.mes);
              }).map(compra => {
                const proveedor = this.getProveedorByIdLocal(compra.id_proveedor);
                if (proveedor) {
                  compra.nit_ncr = proveedor.id_identificador === "1"
                    ? proveedor.documento_identificador.replace(/-/g, "")
                    : "";

                  compra.dui = proveedor.id_identificador = "2"
                    ? proveedor.documento_identificador.replace(/-/g, "")
                    : "";

                  compra.proveedor = proveedor.nombre || "Sin Nombre";
                } else {
                  compra.nit_ncr = "N/A";
                  compra.dui = "N/A";
                  compra.proveedor = "Proveedor Desconocido";
                }
                return compra;
              });


              const id_compra = comprasData.map(item => item.id_compra);

              if (id_compra.length > 0) {
                // Crear los parámetros para la solicitud
                const parametros = {
                  id_compras: id_compra,
                  tipo_doc: "pdf", // Tipo Doc
                  server: "SERVER" // LOCAL o SERVER
                };

                axios.post("api/Facturas/ReporteCompra", parametros)
                  .then(response => {
                    const reporteURL = response.data;

                    // Descargar el archivo PDF
                    const link = document.createElement('a');
                    link.href = reporteURL;
                    link.setAttribute('download', `Anexo_Ventas_${this.anio}_${this.mes}.pdf`);
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);

                    this.base64_doc = "data:application/pdf;base64," + response.data;
                    this.dialog_preview_report = true;

                    this.snackbar_text = "Reporte generado exitosamente";
                    this.snackbar = true;


                    //this.descargarCSVCompras(comprasData);
                  })
                  .catch(error => {
                    this.snackbar_text = "No se pudo generar el reporte de Compras";
                    this.snackbar = true;
                  })
                  .finally(() => {
                    this.loading_facturas = false;
                  });

              } else {
                this.snackbar_text = "No hay Compras para el año y mes seleccionados";
                this.snackbar = true;
                this.loading_facturas = false;
              }
            } else {
              this.snackbar_text = "Error en la respuesta del servidor";
              this.snackbar = true;
              this.loading_facturas = false;
            }
          })
          .catch(error => {
            this.snackbar_text = "No se pudo descargar el archivo de Compras";
            this.snackbar = true;
            this.loading_facturas = false;
          });
      } else {
        console.error("El id_empresa es undefined");
      }
    },


    descargarCSVCompras(data) {
      const csvContent = this.generarCSVCompras(data);
      const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
      const link = document.createElement("a");
      const url = URL.createObjectURL(blob);

      link.href = url;
      link.setAttribute("download", `Anexo_Ventas_${this.anio}_${this.mes}.csv`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      URL.revokeObjectURL(url);
    },

    //Generador del Documento CSV-Compras
    generarCSVCompras(data) {
      const rows = data.map(row => {

        const anulado = (() => {
          if (row.es_anulado == "1") {
            return "1";
          } else if (row.es_anulado === "0") {
            return "0";
          }
        })();

        const renta = (() => {
          if (row.con_renta === "true") {
            return "1";
          } else if (row.con_renta === "false") {
            return "0";
          }
        })();

        return [
          row.proveedor || "",  // A: Nombre del Proveedor
          row.dui || "",  // B: Número de Documento
          row.nit_ncr || "",    // C: NIT del Proveedor
          this.formatDate(row.fecha),  // D: Fecha Emisión (DD/MM/AAAA)
          row.documento,  // E: Tipo de Documento
          row.comp_retencion || "",  // F: Retención
          renta || "",  // G: Renta
          row.serie || "",  // H: Serie
          row.resolucion || "",  // I: Resolución
          row.internas_importaciones || "0.00",  // J: Internas/Importaciones
          row.iva || "0.00",  // K: IVA
          row.renta || "0.00",  // L: Renta
          row.total_operacion || "", // M: Tipo de Operación
          row.total_pagar || "0.00",  // N: Total Compras
          row.fecha_recepcion || "",  // O: Fecha Recepción
          anulado || "",  // P: Anulado
          row.cod_tipo_invalidacion_MH || "",  // Q: Tipo de Invalidación
          row.motivo_invalidacion_MH || "",  // R: Motivo de Invalidación
          row.fecha_resolucion_invalidacion || "",  // S: Fecha de Resolución de Invalidación
          row.resolucion_invalidacion || "",  // T: Resolución de Invalidación
          row.estatus || "",  // U: Estatus
        ].join(";");
      });
      return rows.join("\n");
    },




    dialogNuevoProveedor() {
      this.dialog_crear_editar_proveedor = true;
      this.estado_crear_editar_proveedor = 0;
    },

    dialogEditarProveedor() {
      this.dialog_crear_editar_proveedor = true;
      this.estado_crear_editar_proveedor = this.id_proveedor;
    },

    onChangeTipoDoc() {
      if (this.ver_tipo_docs === 'OTROS' && !this.tienePermisoOtros()) {
        this.snackbar_text = "Faltan Permisos";
        this.snackbar = true;

        this.ver_tipo_docs = 'FSE';
        localStorage.setItem('comprasTipoDoc', 'FSE');

        this.listarCompras();
        return;
      }

      localStorage.setItem('comprasTipoDoc', this.ver_tipo_docs);
      this.listarCompras();
    },

    listarCompras() {
      if (this.$store.state.emp.id_empresa) {
        this.loading_compras = true;
        axios.get("api/Compras/Listar/" + this.$store.state.emp.id_empresa)
          .then((response) => {
            if (Array.isArray(response.data)) {
              this.items_compras = response.data.filter(x =>
                this.ver_tipo_docs === 'OTROS'
                  ? x.cod_doc_fiscal !== 'FSE'
                  : x.cod_doc_fiscal === this.ver_tipo_docs
              );
              //this.aplicarFiltroMesCompras();
            } else {
              console.error("Respuesta no esperada:", response.data);
              this.items_compras = [];

              this.snackbar = true;
            }
            this.loading_compras = false;
          })
          .catch((error) => {
            this.loading_compras = false;
            console.error("Error al listar las compras:", error);
            this.snackbar_text = "No se pudieron cargar las compras";
            this.snackbar = true;
          });
      } else {
        console.error("El id_empresa es undefined");
        this.snackbar_text = "El id_empresa no está definido";
        this.snackbar = true;
      }
    },

    listarDetallesCompras(id_compra) {
      axios.get("api/DetalleCompras/Listar/" + id_compra).then((response) => {
        if (Array.isArray(response.data)) {
          this.items_productos = response.data;
          this.items_productos = response.data.map(p => ({
            ...p,
            descuento_servicio: Number(p.descuento_servicio) || 0,
            precio: Number(p.precio) || 0,
            total_prod: Number(p.total_prod) || 0,
            cantidad_prod: Number(p.cantidad_prod) || 0,
          }));

        } else {
          console.error("Respuesta no esperada:", response.data);
          this.items_productos = [];

          this.snackbar = true;
        }

        // Método para calcular el total
        this.calcularTotalInternasImportaciones();

      })
        .catch((error) => {
          console.error("Error al listar los detalles de la compra:", error);
          this.snackbar_text = "No se pudieron cargar los detalles de la compra";
          this.snackbar = true;
        });
    },


    listarUsuarios() {
      axios.get('api/Usuarios/Listar')
        .then(response => {
          this.items_usuario = response.data;
        })
        .catch(error => {
          console.error('Error al cargar usuarios:', error);
        });
    },

    listarRubro() {
      axios.get("api/Rubro/Listar")
        .then((response) => {

          if (Array.isArray(response.data)) {
            this.items_rubro = response.data;
          } else {
            console.error("La API no devolvió un array:", response.data);
            this.items_rubro = [];
          }
        })
        .catch((error) => {
          console.error("Error al obtener rubros:", error);
          this.items_rubro = [];
        });
    },


    nuevaCompra() {
      if (this.esOtros && !this.mes_compra) {
        this.snackbar_text = "Seleccione el Mes de compra antes de crear.";
        this.snackbar = true;
        return;
      }

      this.anio_ingreso = new Date().getFullYear().toString();
      this.mes_compra = new Date().getMonth() + 1;
      this.fecha = settings.metodos.formatoFechaHora(new Date());
      this.flag = 1;
      this.generarGuid();

      this.id_usuario = this.$store.state.usuario.idUsuario;
      this.nombre_usuario = this.$store.state.usuario.nombre;
      this.rubro = this.$store.state.emp.rubro;

      this.dialog_compras = true;
    },

    listarProveedoress() {
      axios
        .get("api/Proveedores/Listar/" + this.$store.state.emp.id_empresa)
        .then((response) => {
          this.items_proveedores = response.data;
          this.dialog_proveedores = true;
        });
    },

    listarProductos() {
      axios
        .get("api/Productos/Listar/" + this.$store.state.emp.id_empresa)
        .then((response) => {
          this.items_productos_list = response.data;
          this.dialog_productos = true;
        });
    },

    listarSucursales() {
      axios
        .get("api/Sucursales/Listar/" + this.$store.state.emp.id_empresa)
        .then((response) => {
          this.items_sucursales = response.data;
          this.sucursal = response.data[0].id_sucursal;
          this.listarPuntosVenta("auto");
        });
    },

    listarUsuarioSucursal() {
      axios
        .get(
          "api/Usuarios/ListarUsuariosSucursales/" +
          this.$store.state.emp.id_empresa +
          "/" +
          this.$store.state.usuario.idUsuario
        )
        .then((response) => {
          //console.log(response.data);
          this.cod_sucursal_mh = response.data[0].cod_sucursal_mh;
          this.cod_punto_venta_mh = response.data[0].cod_punto_venta_mh;
        });
    },

    listarPuntosVenta(estado) {
      axios
        .get(
          "api/PuntoVentas/ListarXsucursal/" +
          this.$store.state.emp.id_empresa +
          "/" +
          this.sucursal
        )
        .then((response) => {
          //console.log(response.data);
          this.items_punto_venta = response.data;
          this.punto_venta = response.data[0].id_punto_venta;
          this.listarTipoDocs();

          if (estado != "auto" && this.tipo_doc_fiscal == "") {
            this.cod_sucursal_mh = response.data[0].cod_sucursal_mh;
            this.cod_punto_venta_mh = response.data[0].cod_punto_venta_mh;
          } else if (estado != "auto" && this.tipo_doc_fiscal != undefined) {
            this.cod_sucursal_mh = response.data[0].cod_sucursal_mh;
            this.cod_punto_venta_mh = response.data[0].cod_punto_venta_mh;
            this.listarDocSeleccionado();
          }
        });
    },

    //Nuevos

    listarTipoOperacion() {
      axios.get("api/TipoOperacion/Listar")
        .then((response) => {
          this.items_tipo_operacion = response.data;
        });
    },
    listarClasificacion() {
      axios.get("api/Clasificacion/Listar")
        .then((response) => {
          this.items_clasificacion = response.data;
        });
    },
    listarCostoGasto() {
      axios.get("api/CostoGasto/Listar")
        .then((response) => {
          this.items_costogasto = response.data;
        });
    },
    calcularTipoCostoGasto() {
      if (this.tipo_operacion && this.clasificacion) {
        const combinaciones = {
          '1-1': 4,
          '2-2': 1,
          '1-2': 1,
          '2-1': 4,
          '3-1': 4,
          '3-2': 1,
          '9-9': 9,
          '9-1': 9,
          '1-9': 9,
        };

        const key = `${this.tipo_operacion}-${this.clasificacion}`;
        console.log("Key:", key);
        console.log("Tipo de Costo/Gasto encontrado:", combinaciones[key]);

        this.costo_gastos = combinaciones[key] || 'Sin resultado';
      }
    },

    calcularTipoCostoGastoo() {
      if (this.clasificacion && this.tipo_operacion) {
        const combinaciones = {
          '1-1': 4,
          '2-2': 1,
          '1-2': 1,
          '2-1': 4,
          '3-1': 4,
          '3-2': 1,
          '9-9': 9,
          '9-1': 9,
          '1-9': 9,
        };

        const key = `${this.clasificacion}-${this.tipo_operacion}`;
        console.log("Key:", key);
        console.log("Tipo de Costo/Gasto encontrado:", combinaciones[key]);

        this.costo_gastos = combinaciones[key] || 'Sin resultado';
      }
    },

    actualizarCostoGastos() {
      if (this.tipo_operacion && this.clasificacion) {
        const combinaciones = {
          '1-1': 4,
          '2-2': 1,
          '1-2': 1,
          '2-1': 4,
          '3-1': 4,
          '3-2': 1,
          '9-9': 9,
          '9-1': 9,
          '1-9': 9,
        };

        const key = `${this.tipo_operacion}-${this.clasificacion}`;
        this.costo_gastos = combinaciones[key] || 'Sin resultado';
      }
    },

    actualizarCostoGastoos() {
      if (this.clasificacion && this.tipo_operacion) {
        const combinaciones = {
          '1-1': 4,
          '2-2': 1,
          '1-2': 1,
          '2-1': 4,
          '3-1': 4,
          '3-2': 1,
          '9-9': 9,
          '9-1': 9,
          '1-9': 9,
        };

        const key = `${this.clasificacion}-${this.tipo_operacion}`;
        this.costo_gastos = combinaciones[key] || 'Sin resultado';
      }
    },

    modoManual(newVal) {
      if (newVal) {
        this.tipo_operacion = null;
        this.clasificacion = null;
        this.costo_gastos = null;
      }
    },



    setProveedor(event, { item }) {
      this.id_proveedor = item.id_proveedor;
      this.cod_prov = item.codigo;
      this.con_percepcion_prov = item.s_percepcion;
      this.con_retencion_prov = item.s_retencion;
      this.nombre_prov = item.nombre;
      this.receptor_prov = item.codigo + "-" + item.documento_identificador;
      this.tamaño_prov = item.tamaño;
      this.registro_prov = item.registro;
      this.dialog_proveedores = false;

      this.clasificacion = item.clasificacion;
      this.tipo_operacion = item.tipo_operacion;
      this.costo_gastos = item.costo_gasto;
    },

    setProductos(event, { item }) {

      this.cod_prod = item.cod_producto;
      this.nombre_prod = item.nom_producto;
      this.precio = item.precio;



      this.calculoTotal(); // función de cálculo total
      this.llamarCalculo();
      this.dialog_productos = false;
    },

    agregarProducto() {
      if (this.validarProducto()) {
        if (this.id_compra) {
          if (this.id_detalle_compra) {
            this.actualizarDetalleCompra();
          } else {
            this.crearDetalleCompra();
          }
        } else {
          this.items_productos.push({

            cod_producto: this.cod_prod,
            cantidad_prod: this.cantidad_prod,
            nom_producto: this.nombre_prod,
            precio: parseFloat(this.precio).toFixed(2),
            descuento_servicio: this.descuento_servicio,
            total_prod: parseFloat(this.total_prod).toFixed(2),
          });

          this.cod_prod = "";
          this.cantidad_prod = "";
          this.nombre_prod = "";
          this.precio = "";
          this.descuento_servicio = "";
          this.total_prod = "";

          // método para calcular el total
          this.calcularTotalInternasImportaciones();

          //metodo para calcular el descuento
          this.sumarDescuentos();


        }
      }

    },

    async obtenerDatosEmpresa(id_empresa) {
      try {
        const response = await axios.get(`api/DetallesEmpresas/BusquedaEmpresa/${id_empresa}`);

        const datos = response.data[0];

        this.rubro = datos.rubro;

      } catch (error) {
        console.error('Error al obtener los datos de la API', error);
      }
    },

    crearCompra() {
      if (this.validarFormulario()) {
        this.loading = true;
        axios
          .post("api/Compras/Crear", {

            id_usuario: this.id_usuario,
            id_tipo_doc_fiscal: this.tipo_doc_fiscal.id_tipo_doc_fiscal,
            id_sucursal: this.sucursal,
            id_proveedor: this.id_proveedor,
            id_empresa: this.$store.state.emp.id_empresa,
            fecha: this.fecha,
            condicion_pago: this.cond_pago,
            documento: this.documento,
            comp_retencion: this.comp_retencion,
            con_renta: this.con_renta,
            serie: this.serie,
            resolucion: this.resolucion,
            fecha_recepcion: this.fecha_recepcion,
            emitir_anulado: this.emitir_anulado,
            num_poliza: this.num_poliza,
            quedan: this.quedan,
            internas_importaciones: this.internas_importaciones,
            iva: this.iva,
            renta: parseFloat(this.renta).toFixed(2),

            //nuevos

            rubro: this.rubro,

            s_retencion: this.s_retencion,
            s_percepcion: this.s_percepcion,

            selec_manual: this.selec_manual,
            tipo_operacion: this.tipo_operacion,
            clasificacion: this.clasificacion,
            costo_gastos: this.costo_gastos,

            no_sujeto: this.no_sujeto,
            internas_importaciones_exentas: this.internas_importaciones_exentas,
            otros_cargos: this.otros_cargos,
            descuento: this.descuento,
            fovial: this.fovial,
            cotrans: this.cotrans,

            fecha_doc: this.fecha_doc,
            mes_compra: this.mes_compra,
            anio_ingreso: this.anio_ingreso,


            total_operacion: this.total_operacion,
            total_pagar: this.total_pagar,
            crearDetalleCompra: this.items_productos,
            estatus: "GUARDADO",


            //nuevo
            fecha_ingreso: this.fecha_ingreso,




          })
          .then(() => {
            this.loading = false;
            if (!this.esOtros) {
              this.incrementarCorrelativoTipoDoc();
            }
            this.listarCompras();
            this.snackbar_text = "Registro creado con éxito";
            this.snackbar = true;
            this.cerrarDialogCompras();
          })
          .catch((error) => {
            console.error("Error al crear la compra:", error);
            this.snackbar_text = "No se pudo crear el registro";
            this.snackbar = true;
            this.loading = false;
          });
      }
    },

    actualizarCompra() {
      if (this.validarFormulario()) {
        const dataToSend = {
          id_compra: this.id_compra,
          id_usuario: this.id_usuario,
          id_tipo_doc_fiscal: this.tipo_doc_fiscal.id_tipo_doc_fiscal,
          id_sucursal: this.sucursal,
          id_proveedor: this.id_proveedor,
          id_empresa: this.id_empresa,
          fecha: this.fecha,
          condicion_pago: this.cond_pago,
          documento: this.documento,
          comp_retencion: this.comp_retencion,
          con_renta: this.con_renta,
          serie: this.serie,
          resolucion: this.resolucion,
          fecha_recepcion: this.fecha_recepcion,
          emitir_anulado: this.emitir_anulado,
          num_poliza: this.num_poliza,
          quedan: this.quedan,
          internas_importaciones: this.internas_importaciones,
          iva: this.iva,
          renta: this.renta,

          //nuevos

          rubro: this.rubro,

          s_retencion: this.s_retencion,
          s_percepcion: this.s_percepcion,

          selec_manual: this.selec_manual,
          tipo_operacion: this.tipo_operacion,
          clasificacion: this.clasificacion,
          costo_gastos: this.costo_gastos,

          no_sujeto: this.no_sujeto,
          internas_importaciones_exentas: this.internas_importaciones_exentas,
          otros_cargos: this.otros_cargos,
          descuento: this.descuento,
          fovial: this.fovial,
          cotrans: this.cotrans,

          fecha_doc: this.fecha_doc,
          mes_compra: this.mes_compra,
          anio_ingreso: this.anio_ingreso,

          total_operacion: this.total_operacion,
          total_pagar: this.total_pagar,
          estatus: "GUARDADO",
          actualizarDetalleCompra: this.items_productos.map(product => ({
            id_detalle_compra: product.id_detalle_compra,
            id_compra: product.id_compra,

            cod_producto: product.cod_producto,
            nom_producto: product.nom_producto,
            cantidad_prod: product.cantidad_prod,
            total_prod: product.total_prod,
            precio: product.precio,
            descuento_servicio: product.descuento_servicio


          })),
        };
        this.loading = true;
        axios
          .put("api/Compras/Actualizar", dataToSend)
          .then(() => {
            this.loading = false;
            this.cerrarDialogCompras();
            this.listarCompras();
            this.snackbar_text = "Registro actualizado con éxito";
            this.snackbar = true;
          })
          .catch((error) => {
            console.error("Error al actualizar la compra:", error.response.data);
            this.snackbar_text = "No se pudo actualizar el registro";
            this.snackbar = true;
            this.loading = false;
          });
      }
    },

    verificarSucursalSeleccionada() {
      if (!this.sucursal || this.sucursal === 0) {
        this.errorSucursal = true;
        this.snackbar_text = "Debe seleccionar una sucursal válida";
        this.snackbar = true;
        return false;
      }
      this.errorSucursal = false;
      return true;
    },

    validarFormulario() {
      let isValid = true;


      this.errorFecha = this.esFSE ? !this.fecha : !this.fecha_doc;

      this.errorSucursal = !this.sucursal;
      this.errorDocumentoIdentificador = !this.tipo_doc_fiscal;
      this.errorCodigoG = this.esFSE ? !this.serie : false;
      this.errorInternas_Importaciones = !this.internas_importaciones;
      this.errorTotal_Operacion = !this.total_operacion;
      this.errorTotal_Pagar = !this.total_pagar;
      this.errorCondicionPago = !this.cond_pago;

      if (
        this.errorFecha || this.errorSucursal || this.errorDocumentoIdentificador ||
        this.errorInternas_Importaciones || this.errorTotal_Operacion ||
        this.errorTotal_Pagar || this.errorCodigoG || this.errorCondicionPago
      ) {
        isValid = false;
      }


      if (isValid && this.esOtros) {
        isValid = this.validateOtrosFechas();
      }

      return isValid;
    },

    validarProducto() {
      let isValid = true;

      this.errorCodigo = !this.cod_prod;
      if (this.errorCodigo) {
        isValid = false;
      }

      return isValid;
    },

    crearDetalleCompra() {
      axios
        .post("api/DetalleCompras/Crear", {
          id_compra: this.id_compra,

          cod_producto: this.cod_prod,
          nom_producto: this.nombre_prod,
          precio: this.precio,

          //nuevos
          cantidad_prod: this.cantidad_prod,
          total_prod: this.total_prod,

          //nuevo
          descuento_servicio: this.descuento_servicio
        })
        .then(() => {

          this.cod_prod = "";
          this.nombre_prod = "";
          this.precio = "";
          this.listarDetallesCompras(this.id_compra);
          this.snackbar_text = "Registro creado con exito";
          this.snackbar = true;

          // Metodo para calcular el total
          this.calcularTotalInternasImportaciones();


        })
        .catch(() => {
          this.snackbar_text = "No se pudo crear el registro";
          this.snackbar = true;
        });
    },

    actualizarDetalleCompra() {
      axios
        .put("api/DetalleCompras/Actualizar", {
          id_detalle_compra: this.id_detalle_compra,
          id_compra: this.id_compra,

          cod_producto: this.cod_prod,
          nom_producto: this.nombre_prod,
          precio: this.precio,

          //nuevos
          cantidad_prod: this.cantidad_prod,
          total_prod: this.total_prod,
          descuento_servicio: this.descuento_servicio
        })
        .then(() => {
          this.id_detalle_compra = "";
          this.cod_prod = "";
          this.nom_producto = "";
          this.precio = "";
          this.cantidad_prod = "";
          this.total_prod = "";
          this.descuento_servicio = "";

          this.listarDetallesCompras(this.id_compra);
          this.snackbar_text = "Registro actualizado con éxito";
          this.snackbar = true;
          this.dialog_compras = false;

          // Metodo para calcular el total
          this.calcularTotalInternasImportaciones();

        })
        .catch(() => {
          this.snackbar_text = "No se pudo actualizar el registro";
          this.snackbar = true;
        });
    },

    limpiar() {
      this.id_usuario = "";
      this.id_proveedor = "";
      this.tipo_doc_fiscal = "";
      this.id_empresa = 0;
      this.fecha = "";
      this.cond_pago = "";
      this.documento = "DTE-00-00000000-000000000000000";
      this.comp_retencion = "";
      this.con_renta = true;
      this.serie = "";
      this.resolucion = "";
      this.fecha_recepcion = "",
        this.emitir_anulado = false;
      this.num_poliza = "";
      this.quedan = "";
      this.cantidad_prod = 1;
      this.cod_prod = "";
      this.nombre_prod = "";
      this.precio = 0;
      this.descuento_servicio = 0;
      this.total_prod = 0;
      this.internas_importaciones = 0;
      this.iva = 0;
      this.renta = 0;
      this.total_operacion = 0;
      this.total_pagar = 0;
      this.gravadas = 0,
        this.exentas = 0,
        this.otros_cargos = 0,
        this.no_sujeto = 0,
        this.retencion = 0,
        this.percepcion = 0,
        this.fovial = 0,
        this.cotrans = 0,
        this.errorCodigo = false;
      this.errorDocumentoIdentificador = false;
      this.errorSucursal = false;
      this.errorInternas_Importaciones = false;
      this.errorTotal_Operacion = false;
      this.errorTotal_Pagar = false;
      this.errorCodigoG = false;
      this.errorCondicionPago = false;


      this.costo_gastos = "";
      this.clasificacion = "";
      this.tipo_operacion = "";

      this.mes = 0;

    },

    editarCompra(item) {

      this.id_compra = item.id_compra;
      this.id_usuario = item.id_usuario;
      this.cargarNombreUsuario(item.id_usuario);
      this.id_proveedor = item.id_proveedor;
      this.id_tipo_doc_fiscal = item.id_tipo_doc_fiscal;
      this.tipo_doc_fiscal = item;
      this.sucursal = item.id_sucursal;
      this.id_empresa = item.id_empresa;
      this.fecha = item.fecha;
      this.cond_pago = item.condicion_pago;
      this.documento = item.documento;
      this.comp_retencion = item.comp_retencion;
      this.con_renta = item.con_renta;
      this.serie = item.serie;
      this.resolucion = item.resolucion;
      this.fecha_recepcion = item.fecha_recepcion;
      this.emitir_anulado = item.emitir_anulado;
      this.num_poliza = item.num_poliza;
      this.quedan = item.quedan;
      this.internas_importaciones = item.internas_importaciones;
      this.iva = item.iva;
      this.renta = item.renta;
      this.total_operacion = item.total_operacion;
      this.total_pagar = item.total_pagar;

      this.rubro = this.items_rubro.find(user => user.id_rubro === item.id_rubro)?.rubro || '';

      //DETALLES DEL PROVEEDOR
      this.cod_prov = item.cod_proveedor;
      this.nombre_prov = item.nom_proveedor;
      this.receptor_prov = item.receptor;
      this.tamaño_prov = item.tamaño;
      this.registro_prov = item.registro;
      this.con_retencion_prov = item.s_retencion;
      this.con_percepcion_prov = item.s_percepcion;
      this.anio_ingreso = item.anio_ingreso;
      this.fovial = item.fovial;
      this.cotrans = item.cotrans;

      this.listarDetallesCompras(item.id_compra);

      this.flag = 2;
      this.dialog_compras = true;
      this.listarTipoDocs();

      this.fecha_doc = item.fecha_doc;
      const mesFromFecha =
        (item.fecha_doc || item.fecha)
          ? (new Date(item.fecha_doc || item.fecha).getMonth() + 1)
          : null;


      this.mes_compra = Number(item.mes_compra || item.id_mes || mesFromFecha);


      if (item.fecha_doc || item.fecha) {
        this.anio_ingreso = new Date(item.fecha_doc || item.fecha).getFullYear();
      }

      this.listarDetallesCompras(item.id_compra);
      this.flag = 2;
      this.dialog_compras = true;
      this.listarTipoDocs();
    },


    editarProducto(item) {
      this.id_compra = item.id_compra;

      this.id_detalle_compra = item.id_detalle_compra;
      this.cod_prod = item.cod_producto;
      this.nombre_prod = item.nom_producto;
      this.precio = item.precio;

      //nuevos
      this.cantidad_prod = item.cantidad_prod;
      this.total_prod = item.total_prod;
      this.descuento_servicio = item.descuento_servicio;
    },

    removerProducto(item) {
      if (item.id_detalle_compra > 0) {
        this.id_detalle_compra = item.id_detalle_compra;
        this.dialog_eliminar_producto_detalle = true;
      } else {
        var index = this.items_productos.findIndex(
          (x) => x.id_detalle_compra == item.id_detalle_compra
        );
        this.items_productos.splice(index, 1);

        // Metodo para calcular el total
        this.calcularTotalInternasImportaciones();


      }
    },

    eliminarProductoDetalle() {
      axios
        .delete("api/DetalleCompras/Eliminar/" + this.id_detalle_compra)
        .then(() => {
          this.dialog_eliminar_producto_detalle = false;
          this.listarDetallesCompras(this.id_compra);
          this.snackbar_text = "El registro se elimino con exito";
          this.snackbar = true;
        })
        .catch(() => {
          this.snackbar_text = "No se pudo eliminar el registro";
          this.snackbar = true;
        });
    },

    //Calculo del IVA
    calculoIva() {
      if (this.tipo_doc_fiscal.cod_doc_fiscal === "CCF") {

        this.iva = parseFloat(Number(this.gravadas) * 0.13).toFixed(2);
      } else if (this.tipo_doc_fiscal.cod_doc_fiscal === "FSE") {
        this.iva = 0; // No aplica IVA para FSE
      }
    },

    //Calculo Descuento
    calculoDescuento() {
      const cantidad = parseFloat(this.cantidad_prod) || 0;
      const precio = parseFloat(this.precio) || 0;
      const porcentajeDescuento = parseFloat(this.descuento_servicio) || 0;

      // Calcula el monto de descuento
      this.monto_descuento = (cantidad * precio * (porcentajeDescuento / 100)).toFixed(2);


      this.descuento = this.monto_descuento;

      this.calcularTotales();
    },


    sumarDescuentos() {
      if (this.descuento_servicio > 0) {
        this.flag_descuento = true;
      }
      this.descuento = parseFloat(
        Number(this.descuento) + Number(this.monto_descuento)
      ).toFixed(2);
    },

    calculoTotal() {
      const cantidad = parseFloat(this.cantidad_prod);
      const precio = parseFloat(this.precio);

      this.total_prod = (cantidad * precio).toFixed(2);
      this.calcularTotales();

      if (!isNaN(cantidad) && !isNaN(precio)) {
        this.total_prod = (cantidad * precio).toFixed(2); //2 decimales
      } else {
        this.total_prod = 0;
      }
    },

    llamarCalculo() {
      for (var i = 0; i < this.items_productos.length; i++) {
        //CALCULOS DE DESCUENTO
        this.sumarDescuentos();
      }
    },


    async enviarDTE(item) {
      //console.log(item);
      this.loading_compras = true;
      axios
        .post("api/ServicioRecepciones/FirmarDocumento2", {
          cod_emp: this.$store.state.emp.id_empresa,
          tipoDte: item.cod_doc_fiscal,
          idFactura: item.id_compra,
          ambiente: await this.obtenerAmbiente(),
        })
        .then((response) => {
          this.loading_compras = false;
          if (response.data.estado == "PROCESADO") {
            this.snackbar_text =
              "FACTURA ENVIADA EXITOSAMENTE: " + response.data.descripcionMsg;
            this.snackbar_obs =
              response.data.observaciones.length > 0
                ? "Observaciones: " + response.data.observaciones
                : "Observaciones: " + "Sin observaciones";
          } else if (response.data.estado == "RECHAZADO") {
            this.snackbar_text =
              "FACTURA RECHAZADO: " + response.data.descripcionMsg;
            this.snackbar_obs =
              response.data.observaciones.length > 0
                ? "Observaciones: " + response.data.observaciones
                : "Observaciones: " + "Sin observaciones";
          }
          this.snackbar = true;
          this.listarCompras();
        })
        .catch(() => {
          this.loading_compras = false;
          this.snackbar_text = "Error de solicitud";
          this.snackbar = true;
        });
    },

    async vistaPreviaPdf(item) {
      //console.log(item);
      this.loading_compras = true;
      axios
        .post("api/ServicioRecepciones/VistaPreviaDTE2", {
          cod_emp: this.$store.state.emp.id_empresa,
          tipoDte: item.cod_doc_fiscal,
          idFactura: item.id_compra,
          ambiente: await this.obtenerAmbiente(),
          es_previo: true,
        })
        .then((response) => {
          //console.log(response.data);
          this.loading_compras = false;
          this.base64_doc = "data:application/pdf;base64," + response.data;
          this.dialog_preview_report = true;
        })
        .catch(() => {
          this.snackbar_text = "No se pudo generar el reporte";
          this.snackbar = true;
          this.loading_compras = false;
        });
    },

    async vistaPreviaPdfSello(item) {
      this.loading_compras = true;
      axios
        .post("api/ServicioRecepciones/DescargarFacturaWeb", {
          cod_emp: this.$store.state.emp.id_empresa,
          tipoDte: item.cod_doc_fiscal,
          idFactura: item.id_compra,
          ambiente: await this.obtenerAmbiente(),
          es_previo: false,
        })
        .then((response) => {
          //console.log(response.data);
          this.loading_compras = false;
          this.base64_doc = "data:application/pdf;base64," + response.data;
          this.dialog_preview_report = true;
        })
        .catch(() => {
          this.snackbar_text = "No se pudo generar el reporte";
          this.snackbar = true;
          this.loading_compras = false;
        });
    },

    confirmarAnularDocumento() {
      this.dialog_confirmar_anular = true;
    },

    async anularFactura() {
      axios
        .post("api/ServicioRecepciones/FirmarDocumento2", {
          cod_emp: this.$store.state.emp.id_empresa,
          tipoDte: "INV",
          idCompra: this.id_compra,
          ambiente: await this.obtenerAmbiente(),
        })
        .then((response) => {
          if (response.data.estado == "PROCESADO") {
            this.snackbar_text =
              "FACTURA ANULADA EXITOSAMENTE: " + response.data.descripcionMsg;
            this.snackbar_obs =
              response.data.observaciones.length > 0
                ? "Observaciones: " + response.data.observaciones
                : "Observaciones: " + "Sin observaciones";
          } else if (response.data.estado == "RECHAZADO") {
            this.snackbar_text =
              "FACTURA RECHAZADA: " + response.data.descripcionMsg;
            this.snackbar_obs =
              response.data.observaciones.length > 0
                ? "Observaciones: " + response.data.observaciones
                : "Observaciones: " + "Sin observaciones";
          }
          this.snackbar = true;
          this.listarCompras();
        })
        .catch(() => {
          this.snackbar_text = "Error de solicitud";
          this.snackbar = true;
        });
    },

    eliminarCompra() {
      this.dialog_eliminar_compra = true;
    },
    confirmarEliminarCompra() {
      this.loading_eliminar_compra = true;
      axios
        .delete(`api/Compras/Eliminar/${this.id_compra}`)
        .then(() => {
          this.snackbar_text = "Compra eliminada exitosamente";
          this.snackbar = true;
          this.dialog_eliminar_compra = false;
          this.cerrarDialogCompras();
          this.listarCompras();
        })
        .catch((error) => {
          const apiMsg =
            error?.response?.data?.message ||
            error?.response?.data?.Message ||
            error?.response?.data ||
            "No se pudo eliminar la compra";
          this.snackbar_text = apiMsg;
          this.snackbar = true;
        })
        .finally(() => {
          this.loading_eliminar_compra = false;
        });
    },

    cerrarDialogCompras() {
      this.dialog_compras = false;

      this.id_compra = 0;
      this.id_proveedor = 0;
      this.id_tipo_doc_fiscal = 0;
      this.id_sucursal = 0;
      this.id_empresa = 0;
      this.fecha = "";
      this.cond_pago = "";
      this.documento = "";
      this.comp_retencion = "";
      this.con_renta = "";
      this.serie = "";
      this.resolucion = "";
      this.emitir_anulado = false;
      this.num_poliza = "";
      this.quedan = "";
      this.internas_importaciones = "";
      this.iva = 0;
      this.renta = "";
      this.total_operacion = "";
      this.total_pagar = "";

      this.items_productos = [];

      //DETALLES DEL PROVEEDOR
      this.cod_prov = "";
      this.nombre_prov = "";
      this.receptor_prov = "";
      this.tamaño_prov = "";
      this.registro_prov = "";
      this.con_retencion_prov = "";
      this.con_percepcion_prov = "";
      this.clasificacion = "";
      this.tipo_operacion = "";
      this.costo_gastos = "";


      this.limpiar();
    },

    cerrarDialogAnexo() {
      this.dialog_anexo = false;
      this.limpiar();
    },
    cerrarDialogConsultaH() {
      this.dialog_buscar_compra = false;
      this.limpiar();
    },

    listarTipoDocs() {
      if (this.sucursal) {
        axios
          .get("api/ConfiFacturas/Listar/" + this.sucursal +
            "/" +
            this.punto_venta +
            "/" +
            this.$store.state.emp.id_empresa
          )
          .then((response) => {
            this.items_tipo_doc_fiscales = response.data;


            if (this.items_productos.length > 0) {


              for (var i = 0; i < this.items_productos.length; i++) {

                //CALCULOS DE EXENTO Y NO SUJETO
                if (this.cliente_exento) {
                  this.calculoExento(this.items_productos[i].total);
                  this.limpiarCamposProductos();
                  continue;
                }

                if (this.items_productos[i].exento) {
                  this.calculoExento(this.items_productos[i].total);
                  this.limpiarCamposProductos();
                  continue;
                }
                if (this.items_productos[i].no_sujeto) {
                  this.calculoNoSujeto();
                  this.limpiarCamposProductos();
                  continue;
                }

                if (this.cliente_retencion) {
                  if (this.total >= 100) {
                    this.retencion = (
                      Number(this.total) * Number(0.01)
                    ).toFixed(2);
                  }
                }
                if (this.cliente_percepcion) {
                  if (this.total >= 100) {
                    this.percepcion = (
                      Number(this.total) * Number(0.01)
                    ).toFixed(2);
                  }
                }

                if (
                  this.tipo_doc_fiscal.cod_doc_fiscal == "CCF" ||
                  this.tipo_doc_fiscal.cod_doc_fiscal == "NDB" ||
                  this.tipo_doc_fiscal.cod_doc_fiscal == "NRM"
                ) {
                  this.calculoIva(this.internas_importaciones);
                  this.llamarCalculo();
                }
              }
            }
          });
      }
    },

    //Calculo de la renta
    // Calculo de retención para renta si aplica
    calculoRetencionRenta() {
      const subTotal = (this.tipo_doc_fiscal &&
        this.tipo_doc_fiscal.cod_doc_fiscal === 'EX')
        ? parseFloat(this.internas_importaciones_exentas) || 0
        : parseFloat(this.internas_importaciones) || 0

      if (this.con_renta &&
        this.tipo_doc_fiscal &&
        ['FSE', 'CCF', 'FAC'].includes(this.tipo_doc_fiscal.cod_doc_fiscal)) {
        this.renta = (subTotal * 0.10).toFixed(2)
      } else {
        this.renta = 0
      }

      if (this.tipo_doc_fiscal &&
        this.tipo_doc_fiscal.cod_doc_fiscal === 'CCF' &&
        this.s_retencion &&
        subTotal >= 100) {
        this.retencion = (subTotal * 0.01).toFixed(2)
      } else {
        this.retencion = 0
      }
      this.calcularTotales()
    },




    listarDocSeleccionado() {

      if (this.esOtros) {
        this.documento = '';
        return;
      }

      var formato = "DTE-";
      var formato_ceros =
        "-" +
        this.cod_sucursal_mh +
        this.cod_punto_venta_mh +
        "-000000000000000";
      var correlativo_length = "";
      var id = 0;

      if (this.tipo_doc_fiscal.id_tipo_doc_fiscal != undefined) {
        id = this.tipo_doc_fiscal.id_tipo_doc_fiscal;
      } else {
        id = this.id_tipo_doc_fiscal;
      }

      axios
        .get(
          "api/ConfiFacturas/ListarSeleccionado/" +
          id +
          "/" +
          this.$store.state.emp.id_empresa +
          "/" +
          this.sucursal +
          "/" +
          this.punto_venta
        )
        .then((response) => {
          //console.log(response.data);
          this.items_tipo_doc_fiscal = response.data;

          this.tipo_doc_fiscal = response.data[0];

          correlativo_length = response.data[0].correlativo.toString().length;

          formato_ceros = formato_ceros.substring(
            0,
            formato_ceros.length - correlativo_length
          );

          this.documento = formato
            .concat(response.data[0].cod_mh_doc_fiscal)
            .concat(formato_ceros)
            .concat(response.data[0].correlativo);
        });
    },

    incrementarCorrelativoTipoDoc() {
      if (this.esOtros) return;

      axios.put("api/ConfiFacturas/Incrementar", {
        id_confi_factura: this.tipo_doc_fiscal.id_confi_factura,
        id_empresa: this.$store.state.emp.id_empresa,
        valor: Number(this.tipo_doc_fiscal.correlativo) + 1,
      })
        .then(() => this.limpiar())
        .catch((error) => {
          console.error("Error al incrementar el correlativo:", error);
          this.snackbar_text = "No se pudo incrementar el correlativo";
          this.snackbar = true;
        });
    },

    formatoFecha(item) {
      return settings.metodos.formatoFechaHora(item);
    },
    async generarGuid() {
      if (this.esOtros) {
        this.serie = '';
        return;
      }
      try {
        const response = await axios.get("api/Compras/GenerarGuid");
        this.serie = response.data;
      } catch (error) {
        console.error("Error al generar GUID:", error);
      }
    },

    // Calculo internas/importaciones
    calcularTotalInternasImportaciones() {

      const total = this.tipo_doc_fiscal && this.tipo_doc_fiscal.cod_doc_fiscal === "EX"
        ? parseFloat(this.internas_importaciones_exentas || 0)
        : parseFloat(this.internas_importaciones || 0);


      if (this.tipo_doc_fiscal && this.tipo_doc_fiscal.cod_doc_fiscal === "EX") {
        this.internas_importaciones_exentas = this.items_productos.reduce((total, item) => {
          return total + parseFloat(item.total_prod || 0);
        }, 0).toFixed(2);
      } else {
        this.internas_importaciones = this.items_productos.reduce((total, item) => {
          return total + parseFloat(item.total_prod || 0);
        }, 0).toFixed(2);
      }

      this.calcularTotales();
      this.calculoRetencionRenta();
    },


    calcularTotales() {

      const subTotal = this.tipo_doc_fiscal && this.tipo_doc_fiscal.cod_doc_fiscal === "EX"
        ? parseFloat(this.internas_importaciones_exentas) || 0
        : parseFloat(this.internas_importaciones) || 0;

      const descuento = parseFloat(this.descuento) || 0;

      this.gravadas = (subTotal - descuento).toFixed(2);


      if (this.tipo_doc_fiscal && this.tipo_doc_fiscal.cod_doc_fiscal === "CCF" && this.internas_importaciones > 0) {
        this.iva = (this.gravadas * 0.13).toFixed(2);
      } else {
        this.iva = 0;
      }


      this.total_operacion = (parseFloat(this.gravadas) + parseFloat(this.iva)).toFixed(2);

      const exentas = parseFloat(this.exentas || 0);
      const noSujeto = parseFloat(this.no_sujeto || 0);
      const otrosCargos = parseFloat(this.otros_cargos || 0);


      this.total_pagar = (
        parseFloat(this.gravadas) +
        parseFloat(this.iva) +
        parseFloat(this.retencion) +
        parseFloat(this.percepcion) +
        parseFloat(this.fovial) +
        parseFloat(this.cotrans) +
        parseFloat(this.importaciones) +
        exentas +
        noSujeto +
        otrosCargos -
        descuento - // Descuento aplicado
        parseFloat(this.renta) // Resta de renta
      ).toFixed(2);
    },


    monthsDiff(a, b) {
      const am = a.getFullYear() * 12 + a.getMonth();
      const bm = b.getFullYear() * 12 + b.getMonth();
      return am - bm;
    },

    validateOtrosFechas() {
      if (!this.esOtros) return true;

      const mesCompraId = parseInt(this.mes_compra, 10);
      if (!mesCompraId) {
        this.snackbar_text = "Debe seleccionar el Mes de compra.";
        this.snackbar = true;
        return false;
      }

      if (!this.fecha_doc) {
        this.snackbar_text = "Debe ingresar la Fecha de compra.";
        this.snackbar = true;
        return false;
      }

      const hoy = new Date();
      const fechaCompra = new Date(this.fecha_doc);
      const mesActualNum = hoy.getMonth() + 1;

      let anioAncla =
        parseInt(this.anio_ingreso, 10) ||
        (fechaCompra ? fechaCompra.getFullYear() : 0) ||
        (mesCompraId > mesActualNum ? hoy.getFullYear() - 1 : hoy.getFullYear());

      const ancla = new Date(anioAncla, mesCompraId - 1, 1);

      const mesActual = new Date(hoy.getFullYear(), hoy.getMonth(), 1);
      if (this.monthsDiff(mesActual, ancla) < 0) {
        this.snackbar_text = "El Mes de compra no puede ser futuro.";
        this.snackbar = true;
        return false;
      }


      if (fechaCompra > hoy) {
        this.snackbar_text = "La Fecha de compra no puede ser futura.";
        this.snackbar = true;
        return false;
      }

      const compraM1 = new Date(fechaCompra.getFullYear(), fechaCompra.getMonth(), 1);
      const diff = this.monthsDiff(ancla, compraM1); // ancla - compra

      if (diff < 0) {
        this.snackbar_text = "La Fecha de compra no puede ser posterior al Mes de compra seleccionado.";
        this.snackbar = true;
        return false;
      }

      if (diff > 3) {
        this.snackbar_text = "Solo puede ingresar compras del Mes de compra y hasta 3 meses anteriores.";
        this.snackbar = true;
        return false;
      }

      return true;
    },



    formatDate(dateString) {
      const date = new Date(dateString);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${day}/${month}/${year}`;
    },

    //Busqueda compra por serie

    limpiarNit(valor) {
      if (!valor) { return ''; }
      var sinGuiones = valor.split('-').join('');
      var sinEspacios = sinGuiones.split(' ').join('');
      return sinEspacios;
    },

    async seleccionarTipoDocPorCodigo(codDoc) {

      await this.listarTipoDocs();
      if (this.items_tipo_doc_fiscales && this.items_tipo_doc_fiscales.length > 0) {
        for (var i = 0; i < this.items_tipo_doc_fiscales.length; i++) {
          var t = this.items_tipo_doc_fiscales[i];
          if (t && t.cod_doc_fiscal === codDoc) {
            this.tipo_doc_fiscal = t;
            break;
          }
        }
      }
    },

    mapearCondicionPago(condicionOperacion) {
      var c = Number(condicionOperacion || 1);
      if (c === 2) { return '02'; }
      return '01';
    },

    construirItemsDesdeCuerpoDocumento(cuerpoDocumento) {
      var lista = [];
      if (!cuerpoDocumento) { return lista; }
      var esArreglo = Array.isArray(cuerpoDocumento);
      var fuente = esArreglo ? cuerpoDocumento : [cuerpoDocumento];

      for (var i = 0; i < fuente.length; i++) {
        var it = fuente[i] || {};
        var cantidad = Number(it.cantidad || 1);
        var precio = Number(it.precioUni || 0);
        var total = it.compra != null ? Number(it.compra) : (cantidad * precio);

        lista.push({
          cod_producto: it.codigo || '',
          cantidad_prod: cantidad,
          nom_producto: it.descripcion || '',
          precio: Number(precio).toFixed(2),
          descuento_servicio: 0,
          total_prod: Number(total).toFixed(2),
          descuento_servicio: it.descuento_servicio || 0
        });
      }
      return lista;
    },


    buscarProveedorPorDocumentoLocal(doc) {
      if (!this.items_proveedores) { return 0; }
      for (var key in this.items_proveedores) {
        var p = this.items_proveedores[key];
        if (p && p.documento_identificador) {
          var local = this.limpiarNit(p.documento_identificador);
          if (local === doc) {
            return p.id_proveedor;
          }
        }
      }
      return 0;
    },


    async asegurarProveedorDesdeEmisor(emisor) {

      var nit = this.limpiarNit(emisor && emisor.nit ? emisor.nit : '');
      if (!nit) { return 0; }


      if (!this.items_proveedores || Object.keys(this.items_proveedores).length === 0) {
        await this.listarProveedores();
      }


      var idEncontrado = this.buscarProveedorPorDocumentoLocal(nit);
      if (idEncontrado) { return idEncontrado; }


      if (!this.proveedor_dte) { return 0; }

      var payload = {
        id_departamento: this.id_departamento,
        id_municipio: this.id_municipio,
        id_identificador: this.id_identificador || "1", // 1=NIT
        id_pais: this.id_pais,
        id_empresa: this.$store.state.emp.id_empresa,
        id_actividad_economica: this.id_actividad_economica,

        codigo: this.codigo || nit.substring(nit.length > 6 ? (nit.length - 6) : 0),
        nombre: this.nombre || (emisor && emisor.nombre ? emisor.nombre : "Proveedor"),
        direccion: this.direccion || (emisor && emisor.direccion && emisor.direccion.complemento ? emisor.direccion.complemento : ""),
        tamaño: this.tamaño,
        correo_1: this.correo_1 || (emisor && emisor.correo ? emisor.correo : ""),
        correo_2: this.correo_2,
        telefono: this.telefono || (emisor && emisor.telefono ? emisor.telefono : ""),
        documento_identificador: nit,
        registro: this.registro || (emisor && emisor.nrc ? emisor.nrc : ""),
        con_retencion: this.con_retencion || false,
        activo: this.activo || true,
        exento: this.exento || false,
        con_percecion: this.con_percepcion || false,
        exterior: this.extranjero || false,
        area: this.area,


        selec_manual: this.selec_manual || false,
        tipo_operacion: this.tipo_operacion,
        clasificacion: this.clasificacion,
        costo_gastos: this.costo_gastos
      };

      try {
        await axios.post("api/Proveedores/Crear", payload);

        await this.listarProveedores();
        var nuevoId = this.buscarProveedorPorDocumentoLocal(nit);
        return nuevoId || 0;
      } catch (e) {
        console.error("No se pudo crear el proveedor automáticamente", e);
        return 0;
      }
    },

    mapearTipoDocFiscalDesdeDTE(tipoDte) {

      var cod = String(tipoDte || '');
      if (cod === '01') { return 'FAC'; }
      if (cod === '03') { return 'CCF'; }
      return '';
    },

    aplicarResumenEnMontos(resumen, codDoc) {

      var gravada = Number(resumen?.totalGravada || 0);
      var exenta = Number(resumen?.totalExenta || 0);
      var iva = Number(resumen?.totalIva || 0);
      var reteR = Number(resumen?.reteRenta || 0);


      if (this.esOtros) {
        if (reteR > 0) {
          this.con_renta = true;
        } else {
          this.con_renta = false;
        }
      }


      let tributos = Array.isArray(resumen?.tributos) ? resumen.tributos : [];

      let tribCotrans = tributos.find(t => t.codigo === "C8");
      let tribFovial = tributos.find(t => t.codigo === "D1");

      this.cotrans = tribCotrans ? Number(tribCotrans.valor) : 0;
      this.fovial = tribFovial ? Number(tribFovial.valor) : 0;

      var totOp = Number(resumen?.montoTotalOperacion || (gravada + iva));
      var totPag = Number(resumen?.totalPagar || (gravada + exenta + iva - reteR));

      this.internas_importaciones = gravada.toFixed(2);
      this.internas_importaciones_exentas = 0;

      this.iva = iva.toFixed(2);
      this.renta = reteR.toFixed(2);
      this.total_operacion = totOp.toFixed(2);
      this.total_pagar = totPag.toFixed(2);

      this.no_sujeto = Number(resumen?.totalNoSuj || 0).toFixed(2);
      this.otros_cargos = Number(this.otros_cargos || 0).toFixed(2);
      this.descuento = Number(resumen?.totalDescu || 0).toFixed(2);
    },

    async BuscarCompra() {
      this.loading = true;

      var codigoGeneracion = (this.serie && this.serie.trim && this.serie.trim() !== '' ? this.serie : this.codigo_generacion) || '';
      if (codigoGeneracion && codigoGeneracion.trim) { codigoGeneracion = codigoGeneracion.trim(); }
      var fechaOrigen = this.fecha_doc ? this.fecha_doc : (this.fecha_dte ? this.fecha_dte : this.fecha);
      var fechaEmision = settings.metodos.formatoFecha(fechaOrigen);

      if (!codigoGeneracion || !fechaEmision) {
        this.snackbar_text = "Debe ingresar Código de Generación y Fecha de Emisión.";
        this.snackbar = true;
        this.loading = false;
        return;
      }

      try {
        var response = await axios.post("api/Facturas/BuscarDocumentoHacienda", {
          codigoGeneracion: codigoGeneracion,
          fechaEmision: fechaEmision
        });

        if (!response || !response.data || !response.data.documento) {
          this.snackbar_text = "Documento no encontrado en Hacienda.";
          this.snackbar = true;
          return;
        }

        await this.procesarDocumentoHacienda(response.data);

        var data = response.data;
        var doc = data.documento;

        // DTE desde Hacienda
        var tipoDte = (doc.identificacion && doc.identificacion.tipoDte) ? doc.identificacion.tipoDte : data.tipoDte;
        var codDoc = this.mapearTipoDocFiscalDesdeDTE(tipoDte);

        if (codDoc !== 'FAC' && codDoc !== 'CCF') {
          this.snackbar_text = "Por el momento solo se admite FACTURA (FAC) y CREDITO FISCAL (CCF).";
          this.snackbar = true;
          return;
        }

        await this.seleccionarTipoDocPorCodigo(codDoc);

        // Proveedor (EMISOR)
        var emisor = doc.emisor || {};
        var nitLimpio = this.limpiarNit(emisor.nit);
        var idProv = await this.asegurarProveedorDesdeEmisor(emisor);
        if (idProv) {
          this.id_proveedor = idProv;
        }
        this.nombre_prov = emisor && emisor.nombre ? emisor.nombre : '';
        this.cod_prov = nitLimpio;
        this.receptor_prov = nitLimpio;
        this.registro_prov = emisor && emisor.nrc ? emisor.nrc : '';

        // Cabecera y fechas
        var ident = doc.identificacion || {};
        var resumen = doc.resumen || {};

        this.cond_pago = this.mapearCondicionPago(resumen.condicionOperacion);
        this.documento = ident.numeroControl ? ident.numeroControl : this.documento;
        this.serie = ident.codigoGeneracion ? ident.codigoGeneracion : codigoGeneracion;
        this.resolucion = data.selloVal ? data.selloVal : this.resolucion;
        this.fecha_recepcion = data.fechaProcesado ? data.fechaProcesado : this.fecha_recepcion;

        var ymd = ident.fecEmi ? ident.fecEmi : (data.fechaEmi ? data.fechaEmi : '');
        var hhmm = ident.horEmi ? ident.horEmi : (data.horaEmi ? data.horaEmi : '00:00');
        if (hhmm && hhmm.length >= 5) { hhmm = hhmm.substring(0, 5); }
        if (ymd && ymd.length >= 10) {
          if (this.esOtros) {
            this.fecha_doc = ymd + "T" + hhmm;
            var fechaTmp = new Date(ymd);
            this.mes_compra = Number(fechaTmp.getMonth()) + 1;
          } else {
            this.fecha = ymd + "T" + hhmm;
          }
        }

        // Detalle
        var items = this.construirItemsDesdeCuerpoDocumento(doc.cuerpoDocumento);
        this.items_productos = items;

        // Montos
        this.aplicarResumenEnMontos(resumen, codDoc);


        this.calcularTotalInternasImportaciones();
        this.calculoRetencionRenta();
        this.calcularTotales();

        this.snackbar_text = "Documento importado y relacionado.";
        this.dialog_buscar_compra = false;
      } catch (error) {
        var apiMsg = (error && error.response && (error.response.data && (error.response.data.message || error.response.data.Message || error.response.data)))
          ? (error.response.data.message || error.response.data.Message || error.response.data)
          : (error && error.message ? error.message : "Error al consultar Hacienda");
        this.snackbar_text = apiMsg;
      } finally {
        this.snackbar = true;
        this.loading = false;
      }
    },

    async procesarDocumentoHacienda(data) {
      if (!data || !data.documento) {
        this.snackbar_text = "Documento no válido.";
        this.snackbar = true;
        return;
      }

      var doc = data.documento;

      // DTE desde Hacienda
      var tipoDte = (doc.identificacion && doc.identificacion.tipoDte) ? doc.identificacion.tipoDte : data.tipoDte;
      var codDoc = this.mapearTipoDocFiscalDesdeDTE(tipoDte);

      if (codDoc !== 'FAC' && codDoc !== 'CCF') {
        this.snackbar_text = "Por el momento solo se admite FACTURA (FAC) y CREDITO FISCAL (CCF).";
        this.snackbar = true;
        return;
      }

      await this.seleccionarTipoDocPorCodigo(codDoc);

      // Proveedor (EMISOR)
      var emisor = doc.emisor || {};
      var nitLimpio = this.limpiarNit(emisor.nit);
      var idProv = await this.asegurarProveedorDesdeEmisor(emisor);
      if (idProv) {
        this.id_proveedor = idProv;
      }
      this.nombre_prov = emisor && emisor.nombre ? emisor.nombre : '';
      this.cod_prov = nitLimpio;
      this.receptor_prov = nitLimpio;
      this.registro_prov = emisor && emisor.nrc ? emisor.nrc : '';

      // Cabecera y fechas
      var ident = doc.identificacion || {};
      var resumen = doc.resumen || {};

      this.cond_pago = this.mapearCondicionPago(resumen.condicionOperacion);
      this.documento = ident.numeroControl ? ident.numeroControl : this.documento;
      this.serie = ident.codigoGeneracion ? ident.codigoGeneracion : (data.codigoGeneracion || this.serie);
      this.resolucion = data.selloVal ? data.selloVal : this.resolucion;
      this.fecha_recepcion = data.fechaProcesado ? data.fechaProcesado : this.fecha_recepcion;

      var ymd = ident.fecEmi ? ident.fecEmi : (data.fechaEmi ? data.fechaEmi : '');
      var hhmm = ident.horEmi ? ident.horEmi : (data.horaEmi ? data.horaEmi : '00:00');
      if (hhmm && hhmm.length >= 5) { hhmm = hhmm.substring(0, 5); }
      if (ymd && ymd.length >= 10) {
        if (this.esOtros) {
          this.fecha_doc = ymd + "T" + hhmm;
          var fechaTmp = new Date(ymd);
          this.mes_compra = Number(fechaTmp.getMonth()) + 1;
        } else {
          this.fecha = ymd + "T" + hhmm;
        }
      }

      // Detalle
      var items = this.construirItemsDesdeCuerpoDocumento(doc.cuerpoDocumento);
      this.items_productos = items;

      // Montos
      this.aplicarResumenEnMontos(resumen, codDoc);

      // Recalcular totales
      this.calcularTotalInternasImportaciones();
      this.calculoRetencionRenta();
      this.calcularTotales();

      this.snackbar_text = "Documento importado y relacionado.";
      this.dialog_buscar_compra = false;
      this.snackbar = true;
    },

    abrirDialogoJson() {
      this.jsonFactura = null
      this.jsonFacturaNombre = ''
      this.jsonFacturaError = ''
      this.dialog_cargar_json = true
    },

    onJsonFileSelected(file) {

      const f = Array.isArray(file) ? file[0] : file
      if (!f) {
        this.jsonFacturaNombre = ''
        return
      }
      this.jsonFactura = f
      this.jsonFacturaNombre = f.name
      this.jsonFacturaError = ''
    },

    procesarJsonFactura() {
      if (!this.jsonFactura) {
        this.jsonFacturaError = 'Seleccione un archivo JSON primero.'
        return
      }

      const file = this.jsonFactura

      const reader = new FileReader()
      reader.onload = async (e) => {
        try {
          const text = e.target.result
          const json = JSON.parse(text)


          const data = {
            documento: json,
            tipoDte: json.identificacion && json.identificacion.tipoDte,
            codigoGeneracion: json.identificacion && json.identificacion.codigoGeneracion,
            selloVal: json.respuestaMH && json.respuestaMH.selloRecibido,
            fechaProcesado: json.respuestaMH && json.respuestaMH.fhProcesamiento,
            fechaEmi: json.identificacion && json.identificacion.fecEmi,
            horaEmi: json.identificacion && json.identificacion.horEmi,
            respuestaMH: json.respuestaMH
          }


          await this.procesarDocumentoHacienda(data)

          this.snackbar_text = 'Factura importada desde archivo JSON.'
          this.snackbar = true
          this.dialog_cargar_json = false
        } catch (err) {
          console.error(err)
          this.jsonFacturaError = 'El archivo no contiene un JSON válido o el formato no es el esperado.'
        }
      }

      reader.onerror = () => {
        this.jsonFacturaError = 'Error al leer el archivo.'
      }

      reader.readAsText(file)
    },

    tienePermisoOtros() {
      var id = this.$store.state.usuario.idUsuario;
      return this.UsuariosPermitidos &&
        this.UsuariosPermitidos.indexOf(Number(id)) !== -1;
    },

    cargarNombreUsuario(idUsuario) {
      if (!idUsuario) {
        this.nombre_usuario = "";
        return;
      }

      axios
        .get(`api/Usuarios/Listar/${idUsuario}`)
        .then((response) => {
          const usuario = (response.data && response.data[0]) || null;
          this.nombre_usuario = usuario ? usuario.nombre : "";
        })
        .catch((error) => {
          console.error("Error al cargar usuario de la compra:", error);
          this.nombre_usuario = "";
        });
    },

    aplicarFiltroMesCompras() {
      if (!this.esOtros) {
        this.items_compras = this.items_compras_all || [];
        return;
      }
      const mes = Number(this.mes_compra_filtro);
      if (!mes) {
        this.items_compras = this.items_compras_all || [];
        return;
      }
      this.items_compras = (this.items_compras_all || []).filter(item => {
        const f = item.fecha_doc || item.fecha;
        if (!f) return false;
        const m = new Date(f).getMonth() + 1;
        return m === mes;
      });
    },

  },
};
</script>